import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef, HostListener, ViewEncapsulation } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router } from '@angular/router';
import { NgForm, FormGroup } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DICE_QUOTES_CONFIG, FILE_UPLOAD_CONFIG, PRODUCT_CONFIG, FORM_MSGS } from '../../_common/product-config';
import { QuoteBasicInformation } from '../_models/quote-basic-information';
import { QuoteApplication } from '../_models/quote-application';
import { QuoteCoverages } from '../_models/quote-coverages';
import { DiceQuoteForm, BusinessAddress, MailingAddress, BillingAddress, PrimaryContact, ContactObject } from '../_models/dice-quote';
import { CopyQuote, Coverage } from '../_models/dice-quote';
import { StatusCode, AddressType, DiceSteps, DiceFormStatus, WCpayroll, NewBusiness, HiredorBorrowedPD, VerifyAddressTypes, DandBEventsTypes, EditorOptionTypeEnum } from '../../_common/_enum/module.enum';
import { Channel, DiceQuoteTypes, LobCodes, CustomInputType, YesNo, WOS } from '../../_common/_enum/module.enum';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/_helpers/pending-changes-guard.guard';
import { DnBEventLog } from 'src/app/_models/event-logging';
import {v4 as uuidv4 } from 'uuid';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-create-quote',
  templateUrl: './create-quote.component.html',
  styleUrls: ['./create-quote.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CreateQuoteComponent implements OnInit, ComponentCanDeactivate {
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private diceSteps = DiceSteps;
  private selectedStep: string = null;

  private addressTypeEnum = AddressType;
  private _productConfig = PRODUCT_CONFIG; // used in Html
  private _formMsgs = FORM_MSGS; // used in Html
  private wcpayrollEnum = WCpayroll;
  private lobCodes = LobCodes;
  private customInputTypes = CustomInputType;
  private yesNoEnum = YesNo; // used in Html
  private wos = WOS;

  private diceCopyQuoteModel = new CopyQuote();

  private businessAddress = new BusinessAddress();
  private mailingAddress = new MailingAddress();
  private billingAddress = new BillingAddress();

  private verifyAddressTypes = VerifyAddressTypes;

  private addresses: any = [];  
  private addressTypeValidated: string = this.addressTypeEnum.Business;

  private continueToBasicInfoClicked: boolean = false;
  private continueToAppClicked: boolean = false;
  private continueToCoverageClicked: boolean = false;
  private continueToReviewClicked: boolean = false;
  private submitBtnClicked: boolean = false;
  private backToSearchClicked: boolean = false;

  private _isValidMailingAddress: boolean = false;
  private mailingUpdated: boolean = false;
  private _isValidBillingAddress: boolean = false;
  private billingUpdated: boolean = false;

  private clearedAccount: boolean = false;
  private hasError: boolean = false;
  private discardingQuote: boolean = false;

  private foundAddresses: any;
  private currentAddressesTypes = [];

  private todaysDate: Date = new Date();

  private glLob: any;
  private dpLob: any;
  private auLob: any;
  private umLob: any;
  private wcLob: any;

  private hiredorBorrowedPDConst: string = HiredorBorrowedPD.HiredorBorrowedPDConst;
  private hiredOrBorrowed: any;

  private coverage = new Coverage();

  private uploadedFileSize: number = 0;
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML
  private attachmentError: string = null;
  private supportingDocuments = [];
  private finalDocumentsList: any = [];
  private _accountLegalEntity: any;

  private accEntityLegalDisplayName: any = '';

  private questionAnswers: any = [];  
  
  private diceFormStatus = DiceFormStatus;

  private isDupDiceAccount: boolean = false;
  
  private errorMessages = DICE_QUOTES_CONFIG.FormErrorMessages;
  private dbaMaxChars = DICE_QUOTES_CONFIG.InputMaxChars;
  private officers = DICE_QUOTES_CONFIG.Officers;

  private isActivityExistInProduction : boolean = false;

  private diceQuotesConfig = DICE_QUOTES_CONFIG;
  private modalMessages = this.diceQuotesConfig.ModalMessages;
  private docFiles: any = [];
  private isAllDocTypesSelected = false;
  private qaReferenceData: any;

  private diceQuoteForm: DiceQuoteForm;

  private loading: boolean = false;
  private isFormValidating: boolean = false;  //for button loader

  public lookupReferenceData: any;

  private activityList: any = [];

  private mediaList: any = [];
  private mediaListReferenceData: any = [];

  private address: any;  
  private clearAccountDetails: any;    //Required during Duplicate Account Validation API
  private accountList: any = [];
  private accountSelected = false;

  private successMessage;
  private errorMessage;

  private basicInfo = new QuoteBasicInformation();
  private insuranceApplication = new QuoteApplication();
  private quoteCoverages = new QuoteCoverages();  

  private isInsuredVerified = this.diceQuotesConfig.Address.Verified;
  private isMailingVerified = this.diceQuotesConfig.Address.Verified;
  private isBillingVerified = this.diceQuotesConfig.Address.Verified;
  private validatedBusinessAddress: boolean = false;

  private isMediaLength: boolean = true;

  private policyDate: NgbDateStruct;

  private policyEffectiveDate = {};
  private policyMaxDate = {};
  private policyDateMaxDays: number = 60;   //Policy Effective Date on Calendar will be 60 days starting today
  private isDisabledDates: any; //(date: NgbDate, current: {month: number}) => date.day === 13;  

  private isDicePortfolioAdded: boolean = false;
  private isBusinessAutoAdded: boolean = false;
  private isUmbrellaAdded: boolean = false;
  private isWorkCompAdded: boolean = false;

  private underlyingPolicyList: any = [];

  private resetBasicInfoForm = false;
  private resetApplicationForm = false;
  private resetCoveragesForm = false;
  private wcClassCodes: any = []; //lookupReferenceData.classCodes
  
  private wcSecondaryAddr: any = null;
  private isWCFeinOverridden: boolean = false;
  private wcFein: string = null;
  private wcList = [];
  private hasNonZeroPayroll: boolean = false;

  private defaultCity: any = {
    city: 'Select...',
    state: '',
    stateCode: ''
  }
  private loadingCity: any = {
    city:'Loading...',
    state: '', 
    stateCode: ''
  }
  private noCityAvailable: any = {
    city:'No City Available',
    state: '', 
    stateCode: ''
  }
  private defaultPerson: any = {
    caption: 'Select...',
    value: ''
  }
  private loadingPerson: any = {
    caption:'Loading...',
    value: ''
  }
  private noPersonAvailable: any = {
    caption:'No Person Available',
    value: ''
  }
  private personListLoading: boolean = false;

  private isBusinessLookup: boolean = false;
  private backToBusinessLookup: boolean;
  private disabledDiceQuoteForm: any = {
    accountName: false,
    dbaName: false,
    businessAddress: false,
    businessAddressLine2: false,
    mailingAddress: false,
    mailingAddressLine2: false,
    accountLegalEntity: false,
    accountFein: false
  };

  /*** Child Views for All Forms ***/
  @ViewChild("basicInfoForm", {static: false}) basicInfoForm: NgForm;
  @ViewChild("insuranceAppInfoForm", {static: false}) insuranceAppInfoForm: NgForm;
  @ViewChild("insuredCoveragesForm", {static: false}) insuredCoveragesForm: NgForm;
  @ViewChild("insuredAddressForm", {static: false}) insuredAddressForm: NgForm;
  @ViewChild("duplicateAddressForm", {static: false}) duplicateAddressForm: NgForm;
  @ViewChild('newAccountDetails', {static: false}) newAccountDetails;

  /**** Child View for All Modals ****/
  @ViewChild("discardQuoteModal", {static: false}) discardQuoteModal;
  @ViewChild("generateQuoteModal", {static: false}) generateQuoteModal;
  @ViewChild("addressValidationModal", {static: false}) addressValidationModal;
  @ViewChild("duplicateAccountModal", {static: false}) duplicateAccountModal;
  @ViewChild("clearAccountFailedModal", {static: false}) clearAccountFailedModal;
  @ViewChild("changeAccountModal", {static: false}) changeAccountModal;

  private isValidPrimaryContact: boolean = false;
  private basicInfoFormSubmitted: boolean = false;
  private submitInsuranceAppInfoForm: boolean = false;
  private insuredCoverageFormSubmitted: boolean = false;
  private lobListFromDiceQuoteForm: any = [];

  private diceFormLoaded = false;
  
  private selectedNiche;
  private selectedProducer;
  private diceQuoteDetails: any = {
    diceQuoteType: null,
    applicationId: null,
    quoteId: null
  };
  private diceQuoteTypes = DiceQuoteTypes;

  private _applicationDetail: any = {};
  private _quoteDetail: any = {};

  coveragesForm: FormGroup;

  private acknowledgementText: string = ""; // Using it in HTML
  private acceptAcknowledgement: boolean = false; // Using it in HTML
  private isSubmitted: boolean = false;
  glOccurrenceDisplayVal: any;
  private dnbEventsModel: DnBEventLog;
  private dnbEventsTypes = DandBEventsTypes;
  private currentUserDts: any;
  private existingAttachments: any =  [];
  
  private auHelpText: string = this.errorMessages.auWosExcluded;

  constructor(private diceService: DiceService, private commonService: CommonService, private router: Router, private calendar: NgbCalendar, private formatter: NgbDateParserFormatter, private changeDetector: ChangeDetectorRef, private el: ElementRef) { }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    // insert logic to check if there are pending changes here;
    // returning true will navigate without confirmation
    // returning false will show a confirm dialog before navigating away
    return (!this.diceFormLoaded) || this.isBusinessLookup || this.discardingQuote || this.submitBtnClicked || this.hasError;
  }

  ngOnInit() {
    this.headerData = new HeaderData();
    this.setHeaderData();

    this.diceQuoteForm = new DiceQuoteForm();
    this.setAcknowledgementText();
    this.diceService.resetSupportingDocuments();
    this.selectedNiche = history.state.selectedNiche;
    this.selectedProducer = history.state.selectedProducer;
    this.isBusinessLookup = history.state.isBusinessLookup;

    /** Set Initial DnB Event Model */
    this.setInitialDnBEventLogModel();

    /* this.setFormStatus(2, this.diceSteps.Coverages);

    this.fetchQuoteDetails('5c3272b0-2bb8-4ef6-8a79-abc8a33e262a', '0b5134f8-7244-4b24-84f2-e6cbcd7f95e7'); */

    if(history && history.state && history.state.diceQuoteDetails) {
      this.diceQuoteDetails = history.state.diceQuoteDetails;

      this.isBusinessLookup = history.state.isBusinessLookup;

      if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.New) {
        // fetch reference data from PSOP DB
        this.fetchReferenceData();

        this.selectedNiche = history.state.selectedNiche;
        this.selectedProducer = history.state.selectedProducer;

        if(this.selectedNiche && this.selectedProducer){  
          console.log(this.selectedNiche, " :: ", this.selectedProducer);  
          this.setFormStatus(0, this.diceSteps.BasicInfo);          
          this.diceQuoteForm.acceptAcknowledgement = false;    
          this.diceQuoteForm.producerName = this.selectedProducer.name;
          this.diceQuoteForm.producerCode = this.selectedProducer.code;
        }
        else{
          this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.DICE}});
        }

        this.diceQuote = this.diceQuoteForm;
      } 
      else if (this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.Copy) {
        this.setFormStatus(2, this.diceSteps.Coverages);
        this.fetchQuoteDetails(this.diceQuoteDetails.applicationId, this.diceQuoteDetails.quoteId);
        console.log('this.diceQuoteDetails :: ', this.diceQuoteDetails);
        console.log(this.diceQuoteDetails.applicationId, ' :: ', this.diceQuoteDetails.quoteId);
      } 
      else {
        this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.DICE}});
      }
    }
    else{
      this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.DICE}});
    }
  }

  setHeaderData(details?: any){

    this.headerData.pageTitle = "Create New Quote";

    if(details) {
      this.headerData.pageTitle = details.quoteType;
      this.headerData.detailMenu = [{label: "Account", description: details.accountName}];
    }

    this.diceService.header = this.headerData;  
  }

  get diceQuote(){
    return this.diceService.diceQuote;
  }
  set diceQuote(_diceQuote){
    this.diceService.diceQuote = _diceQuote;
  }

  getReferenceData() {
    this.lookupReferenceData = this.diceService.referenceData;

    console.log('this.lookupReferenceData :: ', this.lookupReferenceData);

    if(!this.lookupReferenceData) {
      this.fetchReferenceData();
    } else {
      this.setInitialFormObject();
    }
  }

  getAddress(_type){
    return this.diceQuoteForm.addresses.find(_address=> {return _address.addressType == _type});
  }

  getAddressIndex(_type){
    return this.diceQuoteForm.addresses.findIndex(_address=> {return _address.addressType == _type});
  }

  getLegalEntity(_entityCode){
    return this.lookupReferenceData.legalEntity.find(_entity=> {return _entity.code == _entityCode});
  }

  removeHyphen(_addressType){
    if(this.getAddress(_addressType)){
      let _zip = this.getAddress(_addressType).zip;
      if(_zip.indexOf("-") == _zip.length-1){
        this.getAddress(_addressType).zip = _zip.substring(0, _zip.length-1);
      }

      console.log('_zip :: ', _zip);
    }
  }

  formatPhoneNumber(str){
    let cleaned = ('' + str).replace(/\D/g, '');
  
    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  
    if (match) {
      return '(' + match[1] + ')' + match[2] + '-' + match[3]
    };
  }

  setPrimaryContact(_isChecked){
    if(!_isChecked){ this.diceQuoteForm.contact = new PrimaryContact(); }
    else { this.diceQuoteForm.contact = new ContactObject(); }
  }
  
  setSameAsAddress(_isChecked, _addressType) {
    if(_addressType == this.addressTypeEnum.Mailing){
      let addressIndex = this.getAddressIndex(this.addressTypeEnum.Mailing);
      if(_isChecked){ 
        this.diceQuoteForm.addresses.splice(addressIndex, 1); 
        this.mailingAddress = this.getAddress(this.addressTypeEnum.Business);
      }
      else { this.diceQuoteForm.addresses.push(new MailingAddress()); }
    }
    else if(_addressType == this.addressTypeEnum.Billing){
      let addressIndex = this.getAddressIndex(this.addressTypeEnum.Billing);
      if(_isChecked) { this.diceQuoteForm.addresses.splice(addressIndex, 1);}
      else { this.diceQuoteForm.addresses.push(new BillingAddress()); }
    }
    console.log(this.diceQuoteForm.addresses);
  }

  setFormStatus(_stepper, _selectedStep) {
    this.selectedStep = _selectedStep;
    if(_stepper === 0) {
      this.basicInfo.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Started;
      this.insuranceApplication.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.NotStarted;
      this.quoteCoverages.formStatus = this.diceFormStatus.NotStarted;

      if(this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) {
        this.basicInfoFormSubmitted = true;
        this.submitInsuranceAppInfoForm = true;
      }
    } 
    else if (_stepper === 1) {
      setTimeout(()=>{
        if(this.resetApplicationForm) {
          this.insuranceAppInfoForm.reset();
        }
      }, 100);
      this.resetBasicInfoForm = false;
      this.basicInfo.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Completed;
      this.insuranceApplication.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Started;
      this.quoteCoverages.formStatus = this.diceFormStatus.NotStarted;

      if(this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) {
        this.basicInfoFormSubmitted = true;
        this.submitInsuranceAppInfoForm = true;
      }
    } 
    else if (_stepper === 2) {
      setTimeout(()=>{
        if(this.resetCoveragesForm) {
          this.insuredCoveragesForm.reset();
        }
      }, 100);
      this.resetApplicationForm = false;
      this.basicInfo.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Completed;
      this.insuranceApplication.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Completed;
      this.quoteCoverages.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Started : this.diceFormStatus.Started;
      if(this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) {  
        this.basicInfoFormSubmitted = true;
        this.submitInsuranceAppInfoForm = true;
      }
    } 
    else if (_stepper === 3) {
      this.continueToReviewClicked = false;
      this.basicInfo.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Completed;
      this.insuranceApplication.formStatus = (this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) ? this.diceFormStatus.Locked : this.diceFormStatus.Completed;
      this.quoteCoverages.formStatus = this.diceFormStatus.Completed;

      if(this.diceQuoteDetails.diceQuoteType === DiceQuoteTypes.Copy) {  
        this.basicInfoFormSubmitted = true;
        this.submitInsuranceAppInfoForm = true;
      }
    }

    window.scrollTo(0,0);
  }
  
  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }

  /*** Fetch Lookup Reference Data to populate values on UI ***/
  fetchReferenceData(_filterDate: any = null) {
    this.loading = true;
    let referenceDataSubscription = this.diceService.fetchReferenceData(_filterDate).subscribe(response => {
      this.loading = false;
      this.lookupReferenceData = response;
      this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
      this.dpLob = this.lookupReferenceData.lobCoverageQA.IM;
      this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
      this.hiredOrBorrowed = this.lookupReferenceData.lobCoverageQA.AU.options[0].selectedOptions[5];
      this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
      this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;
      this.diceService.referenceData = response;
      if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.New) { 
        this.setInitialFormObject();
      } else {
        console.log("_applicationDetail : ", this._applicationDetail);

        this.diceQuoteForm = this._applicationDetail;

        console.log("this.diceQuoteForm : ", this.diceQuoteForm);
        
        this.setInitialFormObjectForCopy();
      }
    }, error=>{
      this.loading = false;
      this.hasError = true;
    });

    this.diceService.runningServices.push(referenceDataSubscription);
  }

  fetchQuoteDetails(_applicationId, _quoteId) {
    this.loading = true;
    let quoteKeys = {
      applicationId: _applicationId,
      quoteId: _quoteId
    }
    
    let quoteDetailsDataSubscription = this.diceService.fetchQuoteDetails(quoteKeys).subscribe(response => {
      this._applicationDetail = response.application;
      this._quoteDetail = response.quoteDetails;

      console.log("response.application : ", response.application);
      let _headerDetails = {
        quoteType: 'Copy Quote',
        accountName: this._applicationDetail.accountName
      }

      this.setHeaderData(_headerDetails);

      this.fetchReferenceData(this._applicationDetail.applicationCreatedDate);
    });

    this.diceService.runningServices.push(quoteDetailsDataSubscription);
  }

  checkIfDisabled(dataelement){
    if(this.diceQuoteForm.thirdPartyName && this.diceQuoteForm.thirdPartyKey && dataelement){ return true; }
    else{ return false; }
  }

  checkIfSpecificWOS(option){
    if(option.keyValueID === this.wos.GLSpecificWaiverofSubrogation && option.value === this.yesNoEnum.YES){
      return true;
    } else { return false;}
}

  setInitialFormObject() {
    this.setQAResponse();
    this.lookupReferenceData.displayExclusion.forEach(exclusion => {
      exclusion.isSelected = false;
    });

    //this.diceQuoteForm.contact = new ContactObject();

    this.isSubmitted = false;

    this.resetBasicInfoForm = false;
    this.resetApplicationForm = false;
    this.resetCoveragesForm = false;

    this.mediaListReferenceData = this.lookupReferenceData.media;
    this.wcClassCodes= this.lookupReferenceData.classCodes;

    this.updateMediaReferenceObject();
    this._accountLegalEntity = this.lookupReferenceData.legalEntity;

    this.setLobInDiceQuoteForm(this.glLob);

    this.setCalendarDate();

    this.updateQuestions(null);
    
    this.uploadedFileSize = 0;

    this.disabledDiceQuoteForm.accountName = this.checkIfDisabled(this.diceQuoteForm.accountName);
    //this.disabledDiceQuoteForm.dbaName = this.checkIfDisabled(this.diceQuoteForm.accountDBAName);
    this.disabledDiceQuoteForm.businessAddress = this.checkIfDisabled(this.getAddress(this.addressTypeEnum.Business));

    this.diceFormLoaded = true;
  }

  setInitialFormObjectForCopy() {
    this.diceQuoteForm.acceptAcknowledgement = false;
    this.basicInfoFormSubmitted = true;
    this.submitInsuranceAppInfoForm = true;
    this.isSubmitted = false;
    this.clearedAccount = true;

    this.setQAResponse();
    this.setCalendarDate();

    let pipe = new DatePipe('en-US');
    this.updateQuestions(pipe.transform(this._applicationDetail.coverage.policyEffectiveDate, 'MM/dd/yyyy', 'UTC'));

    console.log('this.diceQuoteForm - copy :: ', this.diceQuoteForm);

    this.existingAttachments = this._applicationDetail.attachments && this._applicationDetail.attachments.length > 0 ? this._applicationDetail.attachments : [];

    this.businessAddress = this.getAddress(this.addressTypeEnum.Business); //skins.find(x=>x.Id == "1").Name;
    if(this.getAddress(this.addressTypeEnum.Mailing)){ this.mailingAddress = this.getAddress(this.addressTypeEnum.Mailing); }
    else { this.mailingAddress = this.businessAddress; }
    if(this.getAddress(this.addressTypeEnum.Billing)){ this.billingAddress = this.getAddress(this.addressTypeEnum.Billing) }
    else { this.billingAddress = this.mailingAddress; }

    this.wcFein = this.diceQuoteForm.accountFein;

    if(this.diceQuoteForm.accountLegalEntity) {
      this.diceQuoteForm.accountLegalEntity = this.lookupReferenceData.legalEntity.find(x => x.displayName === this.diceQuoteForm.accountLegalEntity).code;
    }

    this.isDupDiceAccount = (this._quoteDetail.accountIndicator == 3) ? true : false;
    this.mediaList = this.diceQuoteForm.coverage.mediaTypes;
    this.diceQuoteForm.coverage.policyEffectiveDate = null;

    this.mediaListReferenceData = this.lookupReferenceData.media;

    console.log('this.diceQuoteForm.coverage.loBs - copy :: ', this.diceQuoteForm.coverage.loBs);

    for(let i=0 ; i < this.mediaListReferenceData.length; i++) {      
      this.mediaListReferenceData[i].isSelected = false;
      this.diceQuoteForm.coverage.mediaTypes.forEach(_media => {
        if(this.mediaListReferenceData[i].mediaName === _media) {
          this.mediaListReferenceData[i].isSelected = true;
        }
      });
    }
    console.log('this.mediaListReferenceData :: ', this.mediaListReferenceData);

    this.diceQuoteForm.coverage.loBs.forEach(lob => {
      if(lob.lobCode === this.glLob.lobCode) {
        this.glLob.options.lobOptionId = lob.options[0].lobOptionId;
        for(let i=0; i<this.glLob.options[0].selectedOptions.length; i++) {
          let q = lob.options[0].selectedOptions.find(q => {return q.keyValueID === this.glLob.options[0].selectedOptions[i].keyValueID});
          if(q){
            this.glLob.options[0].selectedOptions[i].value = q.value;
            this.glLob.options[0].selectedOptions[i].selectedValues = q.selectedValues;
          }
          this.glLob.options[0].selectedOptions[i].displayOptions.forEach(_opt => {
            _opt.isSelected = false;
            console.log(this.glLob.options[0].selectedOptions[i].value, ' :>: ', _opt.answer);
            if(this.glLob.options[0].selectedOptions[i].value === _opt.answer) {
              _opt.isSelected = true;
            }
          });          
        }

        console.log('Copy - this.glLob :: ', this.glLob);
      }
      else if(lob.lobCode === this.dpLob.lobCode || lob.lobCode === this.lobCodes.IMNY) {
        this.isDicePortfolioAdded = true;
        this.dpLob.options.lobOptionId = lob.options[0].lobOptionId;

        console.log('Copy - this.dpLob :: ', this.dpLob);
      } 
      else if(lob.lobCode === this.lobCodes.AU || lob.lobCode === this.lobCodes.AUMA) {
        this.isBusinessAutoAdded = true;
        this.auLob.options.lobOptionId = lob.options[0].lobOptionId;
        this.updateBusinessAutoLob(this.isDicePortfolioAdded);
        for(let i=0; i<lob.options[0].selectedOptions.length; i++) {
          if(lob.options[0].selectedOptions[i].keyValueID === this.wos.AUWaiverofSubAddIns && lob.options[0].selectedOptions[i].value == this.yesNoEnum.YES){
            this.auHelpText = this.errorMessages.auWosIncluded;
          }
          
          this.auLob.options[0].selectedOptions[i].value = lob.options[0].selectedOptions[i].value;

          if(this.auLob.options[0].selectedOptions[i].displayOptions) {
            this.auLob.options[0].selectedOptions[i].displayOptions.forEach(_opt => {
              _opt.isSelected = false;
              console.log(this.auLob.options[0].selectedOptions[i].value, ' :>: ', _opt.answer);
              if(this.auLob.options[0].selectedOptions[i].value === _opt.answer) {
                _opt.isSelected = true;
              }
            });
          }          
        }

        console.log('Copy - this.auLob :: ', this.auLob);
      } 
      else if(lob.lobCode === this.wcLob.lobCode) {
        this.isWorkCompAdded = true;
        this.wcLob.offlineBanner = lob.offlineBanner;
        this.wcLob.options[0].lobOptionId = lob.options[0].lobOptionId;

        if(!this.wcLob.offlineBanner){
          let lobOption = lob.options[0];

          /* copy selected options */
          let selectedOptions = this.wcLob.options[0].selectedOptions;
          lobOption.selectedOptions.forEach(selection => {
            this.copySelections(selectedOptions, selection);
          });

          /* copy locations */
          this.wcLob.options[0].workerOptions = [];
          let workerOptions = this.wcLob.options[0].workerOptions;
          lobOption.workerOptions.forEach((location, locInd) => {
            this.addRemoveWClist(); 
            location.workerLocation.forEach(selection => {
              this.copySelections(workerOptions[locInd].workerLocation, selection);
              if(selection.keyValueID == 'WorkerStreetAdd' && selection.value){
                workerOptions[locInd].addressVerified = true;
              }
            });

            /* copy class code tabs */
            workerOptions[locInd].classCodes = [];
            workerOptions[locInd].workerClassCodes = [];
            location.workerClassCodes.forEach((classTab, classInd) => {
              this.addClassCodeTab(classInd, workerOptions[locInd], classTab[0].value=='Other');
              classTab.forEach(selection => {
                if(selection.keyValueID !== 'TotalPayroll' || (selection.keyValueID == 'TotalPayroll' && classTab[2].value=='false')){
                  this.copySelections(workerOptions[locInd].workerClassCodes[classInd], selection);
                }
              });
            });
            this.zipSearch(workerOptions[locInd], false); //call zip search API, person list API, & update class codes for each location

            /* copy officer tabs */
            workerOptions[locInd].workerPerson = [];
            if(location.workerPerson.length > 0){
              location.workerPerson.forEach((personTab, personInd) => {
                this.addOfficerTab(personInd, workerOptions[locInd]);
                personTab.forEach(selection => {
                  this.copySelections(workerOptions[locInd].workerPerson[personInd], selection);
                });
              });
            } 
          });

        } else{ /* do not send new questions if offlineBanner */
          this.wcLob.questions = lob.questions;
          this.wcLob.options = lob.options;
        }
      }
      else if(lob.lobCode === this.umLob.lobCode) {
        this.isUmbrellaAdded = true;
        this.umLob.offlineBanner = lob.offlineBanner;
        this.umLob.options.lobOptionId = lob.options[0].lobOptionId;
        if(!this.umLob.offlineBanner){
          let lobOption = lob.options[0];
          lobOption.selectedOptions.forEach(selection => {
            let question = this.umLob.options[0].selectedOptions.find(option => {return option.keyValueID == selection.keyValueID});
            if(question){
              question.value = selection.value;
              if(question.keyValueID == 'UnderlyingPolicies'){
                this.underlyingPolicyOptions(true);
                question.displayOptions.forEach(_dispOpt => {
                  this.underlyingPolicyList = question.value.split(", ");
                  this.underlyingPolicyList.forEach((value:any) => {
                    if(_dispOpt.answer === value){
                      _dispOpt.isSelected = true;
                    }
                  });
                });
              } else if(question.displayOptions){
                question.displayOptions.forEach(_dispOpt => {
                  if(_dispOpt.answer === question.value){
                    _dispOpt.isSelected = true;
                  }
                });
              }
            }
          });
          /* if no underlying policies have been selected, force user to reanswer the first question */
          if(lobOption.selectedOptions.length < 3){
            this.umLob.options[0].selectedOptions[0].value = '';
          }
        } else {
          this.umLob.options = lob.options; //do not send new questions if offlineBanner
        }
        console.log('Copy - this.umLob :: ', this.umLob);
      }
    });
    
    this.loading = this.isWorkCompAdded && !this.wcLob.offlineBanner;
    this.diceFormLoaded = !this.isWorkCompAdded || (this.isWorkCompAdded && this.wcLob.offlineBanner);

    console.log('setInitialFormObjectForCopy - this._applicationDetail.attachments :: ', this._applicationDetail.attachments);
    console.log('setInitialFormObjectForCopy - this.docFiles :: ', this.docFiles);
    console.log('this.diceQuoteForm.attachments :: ', this.diceQuoteForm.attachments);

    console.log('Copy - diceQuoteForm :: ', this.diceQuoteForm);
  }

  copySelections(questions, selection){
    let question = questions.find(option => {return option.keyValueID == selection.keyValueID});
    if(question){
      question.value = (question.optionType == EditorOptionTypeEnum.BOOLEAN && !question.displayOptions) ? (selection.value == 'true' ? true : false) : selection.value;
      question.additionalInfo = selection.additionalInfo; 
      question.selectedValues = selection.selectedValues; 
      if(question.displayOptions){
        question.displayOptions.forEach(_dispOpt => {
          if(_dispOpt.answer === question.value){
            _dispOpt.isSelected = true;
          }
        });
      }
    }
  }

  setQAResponse(){
    this.qaReferenceData = this.lookupReferenceData.qa;

    if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.New) {
      for(let i = 0; i< this.qaReferenceData.length; i++) {
        let tempQA: any = {
          questionID : this.qaReferenceData[i].questionID,
          fullText: this.qaReferenceData[i].questionText,
          answer: null,
          additionalInfo: null,
          shortText: this.qaReferenceData[i].questionShortText,
          questionSectionID: this.qaReferenceData[i].questionSectionID
        };
  
        this.diceQuoteForm.questionAnswers.push(tempQA);
      }
    } else {
      let _qa = this.diceQuoteForm.questionAnswers;

      this.qaReferenceData.forEach(option => {
        let qa = _qa.find(question => {return question.questionId == option.questionID});
        option.answers.forEach(selection => {
          if(qa.answer == selection.answerText){
            selection.isSelected = true;
            option.answer = selection.answerText;
          }
        });
      });

      console.log('Copy - this.qaReferenceData', this.qaReferenceData);
    }

    console.log("this.diceQuoteForm.questionAnswers : ", this.diceQuoteForm.questionAnswers);
  }

  updateMediaReferenceObject(){    
    this.mediaListReferenceData.forEach(media => {
      media.isSelected = false;
    });
    console.log("this.mediaListReferenceData :: ", this.mediaListReferenceData);
  }

  /*** Below function is to intialize or whenever we add an Lob on Coverages Form for updating Lob is a separate function ***/
  setLobInDiceQuoteForm(_lob) {
    let count = 0;
    console.log('_lob ::: ', _lob);

    let tempLob = {
        lobCode: _lob.lobCode,
        lobDisplayName: _lob.lobDisplayName,
        options: [
          {
            lobOptionId: _lob.lobCode + (count+1),
            selectedOptions: _lob.options[0].selectedOptions
          }
        ]
    };
    if(this.diceQuoteForm && this.diceQuoteForm.coverage && this.diceQuoteForm.coverage.loBs) {
      if(tempLob.lobCode == this.wcLob.lobCode){
        this.wcLob.options[0].workerOptions[0].workerClassCodes[0] = this.wcLob.options[0].workerOptions[0].workerClassCodes[0].slice(0,5); //remove specify other
        this.wcLob.options[0].workerOptions[0].workerClassCodes[0][2].value = this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.YES; //set if any value
        this.updateNumOfEmp(this.wcLob.options[0].workerOptions[0].workerClassCodes[0]);
        this.wcLob.options[0].workerOptions[0].workerPerson = []; //remove officers
        this.wcLob.options[0].workerOptions[0].selectedCity = ''; //set city dropdown to select
      }
      this.diceQuoteForm.coverage.loBs.push(tempLob);
    }
    
    console.log("setLobInDiceQuoteForm --- _lob :: ", _lob);
    console.log("setLobInDiceQuoteForm --- this.diceQuoteForm.coverage.loBs :: ", this.diceQuoteForm.coverage.loBs);
  }

  /*** Setting up calendar for Policy Effective Date on Coverages Form***/
  setCalendarDate() {
    let _policyEffectiveDate = new Date();
    _policyEffectiveDate.setDate(_policyEffectiveDate.getDate());

    let _date: NgbDate; 

    let _policyMaxDate = new Date();
    _policyMaxDate.setDate(_policyMaxDate.getDate() + this.policyDateMaxDays);

    this.policyEffectiveDate = {year: _policyEffectiveDate.getFullYear(), month: _policyEffectiveDate.getMonth() + 1, day: _policyEffectiveDate.getDate() };
    this.policyMaxDate = {year: _policyMaxDate.getFullYear(), month: _policyMaxDate.getMonth() + 1, day: _policyMaxDate.getDate() };
  }

  updateQuestions(date){
    this.lookupReferenceData = this.diceService.getReferenceData();
    let coverages = [{lookup: this.lookupReferenceData.lobCoverageQA.GL, lob: this.glLob}, {lookup: this.lookupReferenceData.lobCoverageQA.AU, lob: this.auLob}, {lookup: this.lookupReferenceData.lobCoverageQA.IM, lob: this.dpLob}, {lookup: this.lookupReferenceData.lobCoverageQA.WC, lob: this.wcLob}, {lookup: this.lookupReferenceData.lobCoverageQA.UMB, lob: this.umLob}];
    coverages.forEach(coverage => {
      if(!coverage.lob.offlineBanner){
        /* add/remove questions based on effective date */
        date = (date) ? new Date(date) : new Date();
        this.addRemoveQuestions(date, coverage.lob.options[0].selectedOptions, coverage.lookup.options[0].selectedOptions);
        if(coverage.lob.lobCode == this.lobCodes.AU || coverage.lob.lobCode == this.lobCodes.AUMA){
          this.updateBusinessAutoLob(this.isDicePortfolioAdded);
        }
        if(coverage.lob.lobCode == this.lobCodes.WC){
          this.addRemoveQuestions(date, coverage.lob.options[0].workerOptions[0].workerLocation, coverage.lookup.options[0].workerOptions[0].workerLocation);
          /* update class codes based on effective date */
          if(this.diceQuoteForm.coverage.policyEffectiveDate){
            coverage.lob.options[0].workerOptions.forEach(wcOption => {
              this.updateClassCodes(wcOption);
            });
          }
        }
      }
    });
  }

  addRemoveQuestions(date, lob, lookup){
    lookup.forEach(question => {
      let q = lob.find(q => {return q.keyValueID === question.keyValueID});
      let expirationDate = new Date(question.expirationDate);
      let effectiveDate = new Date(question.effectiveDate);
      if(!q && expirationDate >= date && effectiveDate <= date){
        lob.push(question);
      } else if(q && (expirationDate < date || effectiveDate > date)){
        lob.splice(lob.indexOf(q), 1);
      }
    });
  }

  /*** Opens Discard Quote Modal ***/
  openDiscardQuoteModal() {
    this.diceService.openModal('none', this.discardQuoteModal, true, 'light-blue-backdrop', true, '', '', false);
  }

  discard(){
    if(this.backToSearchClicked){ this.backToSearch() }
    else{ this.discardQuote() }
  }

  /*** Discard Quote Modal takes you to Quote List page ***/
  discardQuote(){
    this.discardingQuote = true;
    if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.Copy) { 
      this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
      this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
      this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
      this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;
  
      this.diceService.resetSupportingDocuments();
    } else {
      this.resetAllForms();
    }
    
    this.diceService.closeModal();
    this.router.navigate(["newbusiness"], {state: {selectedBusiness: NewBusiness.DICE}});
  }

  resetAllMessages() {
    this.successMessage = "";
    this.errorMessage = "";
  }

  resetAllForms() {
    this.questionAnswers = [];
    this.docFiles = [];
    this.isDicePortfolioAdded = false;
    this.isBusinessAutoAdded = false;
    this.isUmbrellaAdded = false;
    this.isWorkCompAdded = false;
    this.isDupDiceAccount = false;
    this.clearedAccount = false;
    this.mediaListReferenceData = [];

    this.resetBasicInfoForm = true;
    this.resetApplicationForm = true;
    this.resetCoveragesForm = true;

    this.basicInfoFormSubmitted = false;
    this.submitInsuranceAppInfoForm = false;
    this.insuredCoverageFormSubmitted = false;

    this.continueToBasicInfoClicked = false;
    this.continueToAppClicked = false;
    this.continueToCoverageClicked = false;
    this.continueToReviewClicked = false;
    this.backToSearchClicked = false;

    this.addresses = [];
    this.validatedBusinessAddress = false;
    this.isValidPrimaryContact = false;
    this.isActivityExistInProduction = false;
    this.lobListFromDiceQuoteForm = [];
    this.isMediaLength = true;
    this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
    this.dpLob = this.lookupReferenceData.lobCoverageQA.IM;
    this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
    this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
    this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;

    console.log('Reset - this.auLob :: ', this.auLob);
    console.log('Reset - this.umLob :: ', this.umLob);
    console.log('Reset - this.wcLob :: ', this.wcLob);
    
    this.diceQuoteForm = new DiceQuoteForm();
    this.diceQuoteForm.acceptAcknowledgement = false;

    this.setInitialFormObject();

    if(history && history.state) {
      this.selectedNiche = history.state.selectedNiche;
      this.selectedProducer = history.state.selectedProducer;

      console.log(this.selectedNiche, " :: ", this.selectedProducer);

      if(this.selectedNiche && this.selectedProducer){  
        this.diceQuoteForm.producerName = this.selectedProducer.name;
        this.diceQuoteForm.producerCode = this.selectedProducer.code;
      }
    }
    console.log('Reset DiceQuoteForm :: ', this.diceQuoteForm);
    this.diceService.resetSupportingDocuments();

    this.diceService.closeModal();
  }

  resetLobValues(_lob) {
    if(_lob.lobCode === this.dpLob.lobCode || _lob.lobCode === this.auLob.lobCode){
      this.hiredOrBorrowed = this.diceService.getReferenceData().lobCoverageQA.AU.options[0].selectedOptions[5];
      if(_lob.lobCode === this.auLob.lobCode){
        this.auLob = this.diceService.getReferenceData().lobCoverageQA.AU;
      }
    } else if (_lob.lobCode === this.wcLob.lobCode) {
      if(!this.wcLob.offlineBanner){
        this.wcLob = this.diceService.getReferenceData().lobCoverageQA.WC;
      }
    } else if (_lob.lobCode === this.umLob.lobCode) {
      if(!this.umLob.offlineBanner){
        this.umLob = this.diceService.getReferenceData().lobCoverageQA.UMB;
      }
    } 
  }

  /***
   * Below method is called on Continue to Application button
   * Validating Basic Application Form for submitting
        1. setSameAsAddress() - Sets Mailing / Billing addresses based on isSameAs checkboxes
        2. validateAddress() - 
              First do Validate Address check before getting clearance for an account. 
              Opens Address Validation Modal - Broker can pick the address entered on form or the verified address given by api call
        3. clearAccount() - Validates account to be cleared - Returns one of the 4 Account Indicators as below
            a. 0 - Blocked - Indicates the account is associated with some other company
            b. 1 - New - Indicates Brand New Account --> Opens Address Validation Modal
            c. 2 - Duplicate - Is never returned from BE - but needs to  be sent from FE when duplicate account modal is open and user selects the account he entered
            d. 3 - Duplicate - Indicates the account already exists under the same broker producer code and opens DuplicateAccounts Modal
                   i) Receives 1-n number of accounts found and if user selects the accounts sent we need to send the account number as well
                  ii) If the broker selects the address he entered - 
                      - Update the Account Indicator to 2 which is it's a duplicate account but want to create a new one
            e. 4 - ReferredToUnderwriting - Indicates the brokers producer code is associated with its Company but not the broker itself.
        4. setFormStatus() - After all the validations are sucessfully done we goto next tab or step 2 - i.e. Application
  ***/
  submitBasicInfo(_step) {
    this.continueToBasicInfoClicked = true;

    this.resetAllMessages();  
    this.basicInfoFormSubmitted = this.basicInfoForm.valid;

    if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.Copy) {
      this.setFormStatus(1, this.diceSteps.Application);
      console.log('this.diceQuoteDetails.diceQuoteType - Copy!!!!!');
    }
    else if (this.basicInfoForm.valid) {
      if(!this.validatedBusinessAddress){
        this.validateAddress([this.getAddress(this.addressTypeEnum.Business)]);
      } else if(this.validatedBusinessAddress && !this.clearedAccount){
        this.clearAccount(this.diceSteps.Application);
      } else if (this.diceQuoteForm.accountIndicator !== 3 && (!this.diceQuoteForm.isMailingSameAsInsured && this.mailingUpdated) || (!this.diceQuoteForm.isBillingSameAsMailing && this.billingUpdated)) {
        let addresses = [];
        if(!this.diceQuoteForm.isMailingSameAsInsured && this.mailingUpdated){ addresses.push(this.getAddress(this.addressTypeEnum.Mailing)) }
        if(!this.diceQuoteForm.isBillingSameAsMailing && this.billingUpdated){ addresses.push(this.getAddress(this.addressTypeEnum.Billing)) }
        this.validateAddress(addresses);
      } else {
        this.setFormStatus(1, this.diceSteps.Application);
      }
      if(this.diceQuoteForm.isMailingSameAsInsured && this.diceQuoteForm.isBillingSameAsMailing){
        this.diceQuoteForm.isMailingOrBillingSameAsInsured = 0; // both are same as insured
        this.billingAddress = this.mailingAddress;
      } else if(this.diceQuoteForm.isMailingSameAsInsured && !this.diceQuoteForm.isBillingSameAsMailing){
        this.diceQuoteForm.isMailingOrBillingSameAsInsured = 1; // mailing same as insured
      } else if(!this.diceQuoteForm.isMailingSameAsInsured && this.diceQuoteForm.isBillingSameAsMailing){
        this.diceQuoteForm.isMailingOrBillingSameAsInsured = 2; // billing same as mailing
        this.billingAddress = this.getAddress(this.addressTypeEnum.Mailing);
      } else  if(!this.diceQuoteForm.isMailingSameAsInsured && !this.diceQuoteForm.isBillingSameAsMailing){
        this.diceQuoteForm.isMailingOrBillingSameAsInsured = 3; // both mailing and billing are different
      } else{
        this.diceQuoteForm.isMailingOrBillingSameAsInsured = 0; // both are same as insured
        this.billingAddress = this.mailingAddress;
      }
      this.diceQuote = this.diceQuoteForm;
    } else {
      this.continueToAppClicked = true;
      console.log('Form has error');
      const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
      if(formGroupInvalid.length>0){
        (<HTMLInputElement>formGroupInvalid[0]).focus();
        return;
      }
    }
  }

  validateAddress(_addresses) {
    if(_addresses && _addresses.workerLocation){ //address is WC secondary location
      _addresses.addressValidating = true;
      this.wcSecondaryAddr = _addresses;
      _addresses = [{addressLine1: _addresses.workerLocation[_addresses.workerLocation.length-1].value, city: _addresses.workerLocation[1].value, state: _addresses.selectedCity.stateCode, zip: _addresses.workerLocation[0].value, addressType: this.addressTypeEnum.Secondary}];
    } else {
      this.isFormValidating = true;
    }

    let addressValidationSubscription = this.diceService.verifyAddress(_addresses).subscribe((data:any) => {
      this.isFormValidating = false;
      if(this.wcSecondaryAddr) {
        this.wcSecondaryAddr.addressValidating = false;
      }
      this.loading = false;
      this.currentAddressesTypes = [];
      data.forEach((address, index)=>{
        address.submitted.addressType = _addresses[index].addressType;
        address.submitted.careof = _addresses[index].careof;
        address.submitted.verified = this.diceQuotesConfig.Address.Overridden;
        if(address.bestMatch){
          /* only show best match for WC if state, city, & zip match what the user entered */
          if(!this.wcSecondaryAddr || (this.wcSecondaryAddr && address.bestMatch.state == this.wcSecondaryAddr.selectedCity.stateCode && address.bestMatch.city == this.wcSecondaryAddr.workerLocation[1].value && address.bestMatch.zip.slice(0,5) == this.wcSecondaryAddr.workerLocation[0].value)){
            address.bestMatch.addressType = _addresses[index].addressType;
            address.bestMatch.careof = _addresses[index].careof;
            address.bestMatch.verified = this.diceQuotesConfig.Address.Verified;
            this.currentAddressesTypes.push(address.bestMatch.verified);
          }else{
            this.currentAddressesTypes.push(address.submitted.verified);
            address.bestMatch = null;
          }
        }else{
          this.currentAddressesTypes.push(address.submitted.verified);
        }
      });

      this.foundAddresses = data;

      let modalClass=(_addresses.length>1)?'xl':'';
      this.diceService.openModal('none', this.addressValidationModal, false, 'light-blue-backdrop', 'static' , 'submission-address-validation-modal', modalClass);
    },
    error => {
      this.isFormValidating = false;
      this.hasError = true;
      console.log("Address Validation Failed");
    });

    this.diceService.runningServices.push(addressValidationSubscription);
  }

  /*** 
   * Below method is called from Address Validation Modal
   * 
   ***/
  updateAddress(_currentAddressesTypes){
    console.log('Update Address - this.diceQuoteForm.addresses :: ', this.diceQuoteForm.addresses);

    if(!this.wcSecondaryAddr){
      /* Updates the business address and mailing address in the diceQuoteForm Model */
      this.foundAddresses.forEach((foundAddress, index) => {
        let addressIndex = -1;
        if(foundAddress.bestMatch && foundAddress.bestMatch.verified === _currentAddressesTypes[index]){
          addressIndex = this.getAddressIndex(foundAddress.bestMatch.addressType);
          this.diceQuoteForm.addresses[addressIndex] = foundAddress.bestMatch;
        }else{
          addressIndex = this.getAddressIndex(foundAddress.submitted.addressType);
          this.diceQuoteForm.addresses[addressIndex] = foundAddress.submitted;
        }
        if(this.diceQuoteForm.addresses[addressIndex].addressType === this.addressTypeEnum.Business){
          this.validatedBusinessAddress = true;
          this.clearAccount(this.diceSteps.Application);
        }else{
          if(this.diceQuoteForm.addresses[addressIndex].addressType === this.addressTypeEnum.Mailing){
            this.mailingUpdated = false;
          }else if(this.diceQuoteForm.addresses[addressIndex].addressType === this.addressTypeEnum.Billing){
            this.billingUpdated = false;
          }
          if(this.getAddress(this.addressTypeEnum.Business)){ this.businessAddress = this.getAddress(this.addressTypeEnum.Business); }
          if(this.getAddress(this.addressTypeEnum.Mailing)){ this.mailingAddress = this.getAddress(this.addressTypeEnum.Mailing); }
          if(this.getAddress(this.addressTypeEnum.Billing)){ this.billingAddress = this.getAddress(this.addressTypeEnum.Billing); }
          else if(this.diceQuoteForm.isMailingOrBillingSameAsInsured == 2){ this.billingAddress = this.getAddress(this.addressTypeEnum.Mailing); }
          this.setFormStatus(1, this.diceSteps.Application);
        } 
      });
  
      this.basicInfoFormSubmitted = this.basicInfoForm.valid;
    } else {
      /* Updates the WC secondary address */
      this.foundAddresses.forEach((foundAddress: any, index: any) => {
        this.wcSecondaryAddr.workerLocation[this.wcSecondaryAddr.workerLocation.length-1].value = ((foundAddress.bestMatch && foundAddress.bestMatch.verified === _currentAddressesTypes[index])) ? foundAddress.bestMatch.addressLine1 : foundAddress.submitted.addressLine1;
        this.wcSecondaryAddr.addressVerified = true;
      });
      this.wcSecondaryAddr = null;
    }

    this.diceService.closeModal();
  }

  scrollToAccountDetails() {
    window.setTimeout(()=>{
      document.getElementById("companyLegalEntity").focus();
      window.setTimeout(()=>{
      (this.newAccountDetails.nativeElement as HTMLElement).scrollIntoView({behavior:"smooth"});
      },100);
    }, 50);
  }

  /*** Check Account whether it is cleared for submission - Call Clear Account API ***/
  clearAccount(_step){
    this.isFormValidating = true;
    console.log('this.producerCode :: ', this.selectedProducer);

    let _accDetails = {
      channel: Channel.DICE,
      accountName: this.diceQuoteForm.accountName,
      accountCity: this.diceQuoteForm.addresses[0].city,
      accountPostalCode: this.diceQuoteForm.addresses[0].zip,
      accountStateCode: this.diceQuoteForm.addresses[0].state,
      producerCode: this.selectedProducer.code,
      thirdPartySource: {
        thirdPartyName: this.diceQuoteForm.thirdPartyName,
        thirdPartyKey: this.diceQuoteForm.thirdPartyKey,
      }
    };

    let _accountResponse: any;

    console.log("In Validate Account - accDetails :: ", _accDetails);

    let clearAccountSubscription = this.diceService.clearAccount(_accDetails).subscribe(data => {
      this.isFormValidating = false;
      _accountResponse = data;

      console.log('_accountResponse :: ', _accountResponse);
      this.diceQuoteForm.accountIndicator = _accountResponse.accountIndicator;

      /* mapping D&B information */
      this.diceQuoteForm.accountKey = _accountResponse.accounts[0].accountKey;
      if(_accountResponse.accounts[0].thirdPartySource){ 
        this.diceQuoteForm.thirdPartyKey = _accountResponse.accounts[0].thirdPartySource.thirdPartyKey;
        this.diceQuoteForm.thirdPartyName = _accountResponse.accounts[0].thirdPartySource.thirdPartyName; 
        this.getAddress(this.addressTypeEnum.Business).verified = this.verifyAddressTypes.DNBVERIFIED;
      }

      /*** 
       * Account Indicators or Statuses Returned
       * 0 - Blocked
       * 1 - New
       * 2 - Duplicate - never gets returned from BE
       * 3 - Duplicate - Open duplicate account modal
       * 4 - Referred to Underwriting
       ***/

      if(_accountResponse.accountIndicator === 0 || _accountResponse.accountIndicator === 1 || _accountResponse.accountIndicator === 4) {
        this.isDupDiceAccount = false;

        if((_accountResponse.accountIndicator === 1) && _accountResponse.accounts[0].thirdPartySource != null){
          /* mapping business details from DNB */
          this.diceQuoteForm.accountPhoneNumber = this.formatPhoneNumber(_accountResponse.accounts[0].accountPhoneNumber);
          this.diceQuoteForm.accountWebsite = _accountResponse.accounts[0].accountWebsite;
          this.diceQuoteForm.accountFein = _accountResponse.accounts[0].accountFEIN;
          this.diceQuoteForm.thirdPartyFEIN = _accountResponse.accounts[0].accountFEIN;
          this.wcFein = this.diceQuoteForm.accountFein;

          if(_accountResponse.accounts[0].accountOrganizationType && this.getLegalEntity(_accountResponse.accounts[0].accountOrganizationType)){
            this.diceQuoteForm.accountLegalEntity = this.getLegalEntity(_accountResponse.accounts[0].accountOrganizationType).code;
          }
          
          /* mapping addresses from D&B */
          _accountResponse.accounts[0].locations.forEach(address => {
            if(address.accountAddressVerified == this.verifyAddressTypes.DNBVERIFIED){
              let addressData = this.getAddress(address.accountLocationTypeName);
              addressData.addressLine1 = address.accountAddressLine1;
              addressData.verified = address.accountAddressVerified;
              addressData.city = address.accountCity;
              addressData.county = address.accountCountyName;
              addressData.addressType = address.accountLocationTypeName;
              addressData.zip = (address.accountPostalCode.length > 5 && address.accountPostalCode.indexOf('-') === -1) ? address.accountPostalCode.substr(0,5) + '-' + address.accountPostalCode.substr(5, address.accountPostalCode.length - 5) : address.accountPostalCode;
              addressData.state = address.accountStateCode;
              if(address.accountLocationTypeName == this.addressTypeEnum.Mailing){
                addressData.addressLine2 = address.accountAddressLine2;
                //this.disabledDiceQuoteForm.mailingAddress = true;
                this._isValidMailingAddress = true;
                this.mailingAddress = addressData;
                this.mailingUpdated = true;
              }
            }
          });

          /* disabling fields where DNB data has been prefilled */
            this.disabledDiceQuoteForm.businessAddressLine2 = this.checkIfDisabled(this.getAddress(this.addressTypeEnum.Business).addressLine2);
            this.disabledDiceQuoteForm.dbaName = this.checkIfDisabled(this.diceQuoteForm.accountDBAName);
            this.disabledDiceQuoteForm.accountFein = this.checkIfDisabled(this.diceQuoteForm.accountFein);
        }
        this.scrollToAccountDetails();
        this.clearedAccount = true;
      }
      else if(_accountResponse.accountIndicator === 3) {
        this.accountList = [];
        this.isDupDiceAccount = true;
        if(_accountResponse.accounts.length > 0) {
          this.accountList = _accountResponse.accounts;
          this.diceService.openModal('none', this.duplicateAccountModal, false, 'light-blue-backdrop', 'static', 'duplicateAccountModal');
        }
      }
      console.log('this.accountList::: ', this.accountList);
    },
    error => {
      console.log("Clear Account Failed");
      this.isFormValidating = false;
      this.hasError = true;

      let hasOpenModals = this.diceService.hasOpenModals();
      if (hasOpenModals) {
        this.diceService.closeModal();
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.validatedBusinessAddress = false;
          this.basicInfoFormSubmitted = true;
          this.diceService.openModal('none', this.clearAccountFailedModal, false, 'light-blue-backdrop', 'static', 'clearAccountFailedModal');
        }, 50);
      }

    });

    this.diceService.runningServices.push(clearAccountSubscription);
  }

  closeDupAccountModal(_modal){
    _modal.close(); 
    this.validatedBusinessAddress = null;
    this.basicInfoFormSubmitted = true;
  }

  selectDuplicateAccount(_account) {
    console.log("In duplicate Modal :: ", _account);
    this.diceQuoteForm.accountName = _account.accountName;
    this.diceQuoteForm.accountDBAName = _account.accountDBAName;
    this.diceQuoteForm.accountNumber = _account.accountNumber;
    if(_account.accountFEIN){
      this.diceQuoteForm.accountFein = _account.accountFEIN.slice(0,2) + '-' + _account.accountFEIN.slice(2);
      this.wcFein = this.diceQuoteForm.accountFein;
    }

    this.diceQuoteForm.addresses = [];
    _account.locations.forEach(location => {
      this.diceQuoteForm.addresses.push({
        addressType: location.accountLocationTypeName,
        careOf: location.accountLocationCareOf,
        addressLine1: location.accountAddressLine1,
        addressLine2: location.accountAddressLine2,
        city: location.accountCity,
        state: location.accountStateCode,
        zip: location.accountPostalCode,
        county: location.accountCountyName,
        verified: location.accountAddressVerified
      });
    });

    console.log('In duplicate Modal - this.diceQuoteForm :: ', this.diceQuoteForm);

    this.setFormStatus(1, this.diceSteps.Application);
    this.diceService.closeModal();
  }

  backToSearch() {
    this.resetAllForms();
    this.diceQuoteForm.producerCode = this.selectedProducer.code;
    this.diceQuoteForm.producerName = this.selectedProducer.name;
    this.diceQuoteForm.producerCity = this.selectedProducer.producerCity;
    this.diceQuoteForm.producerState = this.selectedProducer.producerState;
    this.diceQuoteForm.searchState = this.diceQuote.searchState;

    this.diceQuote = this.diceQuoteForm;

    this.isBusinessLookup = true;

    this.dnbEventsModel.eventType = DandBEventsTypes.BackToSearch;
    this.dnbEventsModel.choiceIndex = 0;
    this.dnbEventsModel.choice = null;
    this.dnbEventsModel.inCompleteResultCount = 0;
    this.dnbEventsModel.returnResultCount = 0;

    this.diceService.dnbEventLog(this.dnbEventsModel);
  }

  setIsBusinessLookup ($event) {
    this.isBusinessLookup = $event;
    this.disabledDiceQuoteForm.accountName = this.checkIfDisabled(this.diceQuoteForm.accountName);
    this.disabledDiceQuoteForm.dbaName = this.checkIfDisabled(this.diceQuoteForm.accountDBAName);
    this.disabledDiceQuoteForm.businessAddress = this.checkIfDisabled(this.getAddress(this.addressTypeEnum.Business));
    if(this.disabledDiceQuoteForm.businessAddress){ this.validatedBusinessAddress = true; }

    this.disabledDiceQuoteForm.businessAddressLine2 = this.checkIfDisabled(this.getAddress(this.addressTypeEnum.Business).addressLine2);
    this.disabledDiceQuoteForm.accountFein = this.checkIfDisabled(this.diceQuoteForm.accountFein);

    this.clearedAccount = false;
  }

  /*** Submit Insurance Application or Underwriting Questions ***/
  submitInsuranceApplication(_step) {
    this.continueToCoverageClicked = true;

    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }

    this.resetAllMessages();

    if(this.submitInsuranceAppInfoForm) {
      this.diceQuote = this.diceQuoteForm;
      this.setFormStatus(2, _step);
    }
  }

  /*** 
   * 
   * Sets Background to selected radio 
   * params - event, radio options per question, if there are any additionalActivity on selected radio
   * 
   *
   ***/
  setSelectedRadioObj(_event, _qaObj, _additionalActivity, _indx, _option) {    
    _qaObj.answer = _option.answerText;
    this.diceQuoteForm.questionAnswers[_indx].answer = _option.answerText;
  
    if(this.isActivityExistInProduction && this.activityList && this.activityList.length < 1) {
      this.submitInsuranceAppInfoForm = false;
    } else {
      this.submitInsuranceAppInfoForm = this.insuranceAppInfoForm.valid;
    }
  }

  setActivityList(_additionalActivity, _option) {
    this.isActivityExistInProduction = (_additionalActivity && _option.answerText === this.yesNoEnum.YES);
    if(this.isActivityExistInProduction) {
      this.activityList = [];
      this.diceQuoteForm.questionAnswers[this.diceQuoteForm.questionAnswers.length - 1].additionalInfo = [];
      this.lookupReferenceData.displayExclusion.forEach(exclusion => {
        exclusion.isSelected = false;
      });
    }
    
    console.log('this.lookupReferenceData.displayExclusion', this.lookupReferenceData.displayExclusion);
    console.log('this.diceQuoteForm.questionAnswers :: ', this.diceQuoteForm.questionAnswers);
  }
  
  /*** 
   * 
   * Below function is called when  Included Activities question is set to true
   * and user selects(checkbox) all the activities that exist in production
   *
   * ***/
  setSelectedActivities(activity, _event){    
    console.log('_event :: ', _event.target.checked, " :: Event Value :: ", _event.target.value, " :: activity :: ", activity);

    let obj = activity;
    if(_event.target.checked){
      let el = this.activityList.find(itm => itm === activity);
      if(!el) 
        this.activityList.push(obj);
    } else {
      let el = this.activityList.find(itm => itm === activity);
      console.log('el: ', el);
      if(el)
        this.activityList.splice(this.activityList.indexOf(el),1);
    }

    console.log('this.activityList: ', this.activityList);
    this.diceQuoteForm.questionAnswers[this.diceQuoteForm.questionAnswers.length - 1].additionalInfo = this.activityList;
    
    console.log('this.diceQuoteForm.questionAnswers :: ', this.diceQuoteForm.questionAnswers[this.diceQuoteForm.questionAnswers.length - 1]);
    console.log('this.insuranceAppInfoForm.valid :: ', this.insuranceAppInfoForm.valid);

    this.submitInsuranceAppInfoForm = (this.insuranceAppInfoForm.valid && this.activityList && this.activityList.length) > 0 ? true : false;
  }

  checkTabInvalid(type, wcIdx, tabInd){
    let form = document.getElementById(type+''+wcIdx+''+tabInd);
    if(this.continueToReviewClicked && form){
      let tab = document.getElementById(type + '-tab' + wcIdx + '' + tabInd);
      if(form.getElementsByClassName('ng-invalid').length>0){
        if(type == 'class'){
          this.wcLob.options[0].workerOptions[wcIdx].selectedClassCodeTab = tabInd; //select class code tab with errors
        } else{
          this.wcLob.options[0].workerOptions[wcIdx].selectedOfficerTab = tabInd; //select officer tab with errors
        }
        form.classList.add('error-content'); //make form border red
        tab.classList.add('error-tab'); //make tab title red
      } else {
        form.classList.remove('error-content'); //make form border gray
        tab.classList.remove('error-tab'); //make tab title black
      }
    }
  }

  checkNonZeroPayroll(){
    this.hasNonZeroPayroll = false;
    this.wcLob.options[0].workerOptions.forEach(location => {
      location.workerClassCodes.forEach(code => {
        if(code[2].value == false){
          this.hasNonZeroPayroll = true;
        }
      });
    });
    this.wcLob.options[0].workerOptions.forEach((location, wcInd) => {
      let ratingInfo = document.getElementById('ratingInfo' + wcInd);
      if(this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.NO && !this.hasNonZeroPayroll){
        ratingInfo.classList.add('error-content'); //make form border red;
      } else {
        ratingInfo.classList.remove('error-content'); //make form border gray;
      }
    });
  }

  /*** Submit Coverages or Lobs for Quote ***/
  submitCoverages(_step) {
    this.isMediaLength = this.mediaList.length === 0 ? false : true;

    this.continueToReviewClicked = true;
 
    let attachmentsLength = this.docFiles.length;
    if(attachmentsLength > 0) {      
      this.checkAndupdateDocType();
      this.diceQuoteForm.attachments = this.docFiles;
    } else {
      this.isAllDocTypesSelected = true;
    }

    setTimeout(() => {
      if(this.isWorkCompAdded && !this.wcLob.offlineBanner){
        for(let i=0; i<this.wcLob.options[0].workerOptions.length; i++){
          /* check for invalid city */
          if(!this.wcLob.options[0].workerOptions[i].workerLocation[1].value){
            this.insuredCoveragesForm.controls['ratingCity'+i].setErrors({'incorrect': true});
          }

          /* check for class code tab errors */
          for(let j=this.wcLob.options[0].workerOptions[i].workerClassCodes.length-1; j>=0; j--){
            this.checkTabInvalid('class',i, j);
          }
        
          /* check for officer tab errors */
          if(this.wcLob.options[0].workerOptions[i].workerPerson.length>0){
            for(let k=this.wcLob.options[0].workerOptions[i].workerPerson.length-1; k>=0; k--){
              /* check for invalid person */
              if(!this.wcLob.options[0].workerOptions[i].workerPerson[k][1].value){
                this.insuredCoveragesForm.controls['personsRole'+i+''+k].setErrors({'incorrect': true});
              }
              this.checkTabInvalid('officer',i, k);
            }
          }
        }

        /* check for non zero payroll */
        this.checkNonZeroPayroll();
      }

      setTimeout(() => {
        const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
        if(formGroupInvalid.length>0){
          (<HTMLInputElement>formGroupInvalid[0]).focus();
          if(formGroupInvalid[0].tagName.toLowerCase() == 'div'){
            (<HTMLDivElement>formGroupInvalid[0]).scrollIntoView();
          }
          return;
        } else if(this.personListLoading){ 
          document.getElementsByClassName('officer-tabs')[0].scrollIntoView();
          return;
        }

        this.resetAllMessages();
        this.updateGLDipslayForOccurrenceField();
        if(!this.isDupDiceAccount)this.accEntityLegalDisplayName = this.getLegalEntity(this.diceQuoteForm.accountLegalEntity).displayName;


        this.diceQuoteForm.coverage.loBs.forEach(_lob => {
          if(_lob.lobCode === this.glLob.lobCode) {
            _lob.options[0].selectedOptions = this.glLob.options[0].selectedOptions;
          }
          if(this.isBusinessAutoAdded && (_lob.lobCode === this.auLob.lobCode || _lob.lobCode === this.lobCodes.AUMA)) {
            _lob.options[0].selectedOptions = this.auLob.options[0].selectedOptions;
          }
          if(this.isWorkCompAdded && _lob.lobCode === this.wcLob.lobCode) {
            this.diceQuoteForm.accountFein = this.wcFein;    
            _lob.options = this.wcLob.options;
          }
          if(this.isUmbrellaAdded && _lob.lobCode === this.umLob.lobCode) {
            _lob.options[0].selectedOptions = this.umLob.options[0].selectedOptions;
          }
        });

        console.log('submitCoverages - :: ', this.diceQuoteForm.coverage.loBs);

        this.lobListFromDiceQuoteForm = this.diceQuoteForm.coverage.loBs;

        console.log('this.isAllDocTypesSelected :: ', this.isAllDocTypesSelected);
        if(this.isAllDocTypesSelected && this.isMediaLength) {
          this.diceQuote = this.diceQuoteForm;
          this.setFormStatus(3, _step);
        }
      },100);
    },100);
  }

  /*** Below Functions are for Submitting Coverages or Lob Information ***/
  checkDate(_date) {
    let _dt = new Date(_date);
    console.log("_date : ", _date);

    console.log("_dt : ", _dt);
    console.log("Check Date : this.insuredCoveragesForm.valid :: " + this.insuredCoveragesForm.valid);
  }

  mediaSelected(_event, _media) {
    let tempMedias = this.diceQuoteForm.coverage.mediaTypes;

    _media.checked = _event.target.checked;

    if(_event.target.checked) {
      let el = this.mediaList.find(itm => itm === _media.mediaName);
      if(!el) 
        this.mediaList.push(_media.mediaName);      
    } else {
      let el = this.mediaList.find(itm => itm === _media.mediaName);
      console.log('el: ', el);
      if(el)
        this.mediaList.splice(this.mediaList.indexOf(el),1);
    }

    this.isMediaLength = this.mediaList.length === 0 ? false : true;

    this.insuredCoverageFormSubmitted = (this.isMediaLength && this.insuredCoveragesForm.valid) ? true : false;

    this.diceQuoteForm.coverage.mediaTypes = this.mediaList;
  }

  /*** Below function is used to add or remove Lobs from DiceQuoteForm.quotes.lob ***/
  addOrRemoveLob(_action, _lob, _ifInsuredCoveragesFormIsValid) {
    let tempQuoteLob = this.diceQuoteForm.coverage.loBs;

    if(_action === "add") {
      this.setLobInDiceQuoteForm(_lob);
      if(_lob.lobCode === 'WC') {
        _lob.options[0].workerOptions[0].workerLocation[0].value = this.getAddress(this.addressTypeEnum.Business).zip.substring(0,5);
        _lob.options[0].workerOptions[0].workerLocation[1].value = this.getAddress(this.addressTypeEnum.Business).city;
        this.zipSearch(_lob.options[0].workerOptions[0], false);
      }
    } else {
      for (let i=0; i < tempQuoteLob.length; i++) {
        if(tempQuoteLob[i].lobCode === _lob.lobCode) {
          console.log("index :: ", i, tempQuoteLob[i]);
          this.diceQuoteForm.coverage.loBs.splice(i, 1);    //Will remove the 1 object from that index position
          this.resetLobValues(_lob);       
          this.continueToReviewClicked = false;
        }
      }
    }

    if(!this.umLob.offlineBanner) this.underlyingPolicyOptions();
  }

  updateGLDipslayForOccurrenceField() {
    this.glOccurrenceDisplayVal = this.glLob.options[0].selectedOptions[0].value.split(' ');
    console.log('this.glOccurrenceDisplayVal :: ', this.glOccurrenceDisplayVal);
  }

  updateBusinessAutoLob(_isDicePortfolioAdded) {
    console.log('_isDicePortfolioAdded', _isDicePortfolioAdded);
    let hiredOrBorrowedInd = this.auLob.options[0].selectedOptions.findIndex(q=>q.keyValueID=='HiredorBorrowedPD');

    if(_isDicePortfolioAdded && this.isBusinessAutoAdded) {
      if(hiredOrBorrowedInd>-1) this.auLob.options[0].selectedOptions.splice(hiredOrBorrowedInd,1); //remove hired or borrowed question
    } else if(this.isBusinessAutoAdded) { 
      if(hiredOrBorrowedInd==-1) this.auLob.options[0].selectedOptions.push(this.hiredOrBorrowed); //add hired or borrowed question 
    } else {
      if(hiredOrBorrowedInd>-1) this.auLob.options[0].selectedOptions.splice(hiredOrBorrowedInd,1); //remove hired or borrowed question
    }

    console.log('this.auLob.options :: ', this.auLob.options);
  }

  /*** 
   * Below Method currently used only for GL Coverages - Will need to make it more generic 
   * Here params - 
   *      event is the checked event
   *      _option is the radio clicked 
   *      coverage is the highest level Lob
   *      lob used if any different action needs to be executed
   ***/
  setOptionSelected(_event, _option, coverage, lob) {
    coverage.value = _option.answer; 

    console.log("setOptionSelected :: ", coverage , " :::_option::: ", _option);

    console.log("dice.quote.loBs :: ", this.diceQuoteForm.coverage.loBs);
  }

  /***
   * 
   * Whenever the GL Coverage is update it sets the 
   * value for BE and displayValue for FE 
   * Also sets the insuredCoverages form validity
   * 
   ***/
  updateGLCoverages(coverage, option, _selOptionIndex, _isValidInsuredCoveragesForm) {
    console.log(coverage, " ::: ", option, " ::: ", _isValidInsuredCoveragesForm);
    coverage.value = option.answer;
    coverage.displayValue = option.text;

    if(this.checkIfSpecificWOS(coverage)){
      coverage.selectedValues = this.diceService.getReferenceData().lobCoverageQA.GL.options[0].selectedOptions[4].selectedValues;
    } else if(coverage && coverage.selectedValues){
      coverage.selectedValues = [];
    }

    this.insuredCoverageFormSubmitted = (this.mediaList.length === 0) ? false : _isValidInsuredCoveragesForm;
  }

  updateWCOptions(wcOption, tabInd){
    let code = wcOption.classCodes.find(_code=> {return _code.classCodeID == wcOption.workerClassCodes[tabInd][0].selectedValues[0]});
    wcOption.workerClassCodes[tabInd][0].value = code ? code.classCodeValue : 'Other';
    
    let otherCode = wcOption.workerClassCodes[tabInd].find(_option=> {return _option.keyValueID == 'SpecifyOther'});
    if(wcOption.workerClassCodes[tabInd][0].value == 'Other' && !otherCode){
      wcOption.workerClassCodes[tabInd].push(this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerClassCodes[0][5]);
    } else if(wcOption.workerClassCodes[tabInd][0].value !== 'Other' && otherCode){
      wcOption.workerClassCodes[tabInd].splice(wcOption.workerClassCodes[tabInd].length-1, 1);
    }
  }
  
  setAcknowledgementText(){
    this.acknowledgementText = `<p><b>NOTICE</b></p>
    
    <p><b>Applicable in AL, AR, DC, LA, MD, NM, RI and WV:</b> Any person who knowingly (or willfully)* presents a false or fraudulent claim for payment of a loss or benefit or knowingly (or willfully)* presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison. *Applies in MD Only.</p>
    
    <p><b>Applicable in CO:</b> It is unlawful to knowingly provide false, incomplete, or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the policyholder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory Agencies.</p>
    
    <p><b>Applicable in FL and OK:</b> Any person who knowingly and with intent to injure, defraud, or deceive any insurer files a statement of claim or an application containing any false, incomplete, or misleading information is guilty of a felony (of the third degree)*. *Applies in FL only.</p>
    
    <p><b>Applicable in KS:</b> Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or belief that it will be presented to or by an insurer, purported insurer, broker or any agent thereof, any written, electronic, electronic impulse, facsimile, magnetic, oral or telephonic communication or statement as part of, or in support of, an application for the issuance of, or the rating of an insurance policy for personal or commercial insurance, or a claim for payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows to contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act.</p>
    
    <p><b>Applicable in KY, NY, OH and PA:</b> Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties (not to exceed five thousand dollars and the stated value of the claim for each such violation)*. *Applies in NY only.</p>
    
    <p><b>Applicable in ME, TN, VA and WA:</b> It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties (may)* include imprisonment, fines and denial of insurance benefits. *Applies in ME only.</p>
    
    <p><b>Applicable in NJ:</b> Any person who includes any false or misleading information on an application for an insurance policy or who knowingly files a statement of claim containing any false or misleading information is subject to criminal and civil penalties.</p>
    
    
    <p><b>Applicable in Utah:</b> Any person who knowingly presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.</p>
    
    <p><b>Applicable in OR:</b> Any person who knowingly and with intent to defraud or solicit another to defraud the insurer by submitting an application or filing a claim containing a false statement as to any material fact may be violating state law.</p>

    <p><b>CERTIFICATION AND ACKNOWLEDGEMENT</b></p>

    <p>The undersigned/user is an authorized representative of the applicant and represents that reasonable inquiry has been made to obtain the answers to questions on this application. He/she represents that the answers are true, correct and complete to the best of his/her knowledge. The applicant or authorized representative acknowledge and understand that he/she is authorized to make any inquiry it deems appropriate in its sole discretion in connection with this application. Acceptance of this application does not obligate the insurer to issue the insurance being requested hereby, nor does it obligate the applicant to acquire such insurance.</p>
    
    <p>The undersigned/user is an authorized representative of the applicant and acknowledges that, should any of the information or statements contained in this application or in any attachments hereto change in any material respect between the date of the application and the effective date of the policy to be issued in connection with such application, the insurer shall have the right, in its sole discretion, to amend, modify or withdraw any outstanding quotation or agreement to bind insurance. Further, the authorized representative or the applicant undertakes to inform the insurer as promptly as possible of any material change or alteration to such information and statements, whether occurring before or after the issuance of an insurance policy in connection herewith.</p>
    `
  }

  getLobIndexInDiceQuoteForm(_lob) {
    let tempDiceQuoteLob = this.diceQuoteForm.coverage.loBs;
    let _index = 0;
    for(let i = 0; i < tempDiceQuoteLob.length; i++) {
      if(tempDiceQuoteLob[i].lobCode === _lob.lobCode) {
        _index = i;
      }
    }
    console.log("_index :: ", _index);
    return _index;
  }

  checkDiceValue(_lob) {
    let _index = this.getLobIndexInDiceQuoteForm(_lob);
    console.log(this.diceQuoteForm.coverage.loBs[_index].options);
  }

  onUmbrellaLimitChange(val) {
    console.log("Umbrella Limit Value :: ", val);
  }

  /* trackBy directive implemented on rating info loop to appropriately update the DOM */
  ratingInfo(index, item){
    return index;
  }

  addRemoveWClist(_ind=null) {
    if(_ind == null) {
      let options = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0];
      options.workerClassCodes[0] = options.workerClassCodes[0].slice(0,5); //remove specify other
      options.workerClassCodes[0][2].value = this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.YES; //set if any value
      this.updateNumOfEmp(options.workerClassCodes[0]);
      options.workerPerson = []; //remove officers
      this.wcLob.options[0].workerOptions.push(options);
    } else {
      this.wcLob.options[0].workerOptions.splice(_ind,1);
      if(_ind==0){ // if the first location is removed, then check if street address is required for the next
        this.addRemoveWCStreetAddr(this.wcLob.options[0].workerOptions[0]);
      }
    }
  }

  resetZip(_wcOption, _city){
    _wcOption.citiesByZip = _city;
    _wcOption.selectedCity = _wcOption.citiesByZip[0];
    _wcOption.workerLocation[1].value = '';
    _wcOption.workerLocation[2].value = '';
    _wcOption.addressVerified = false;
    _wcOption.workerLocation = _wcOption.workerLocation.slice(0,4); //remove street address
  }

  zipSearch(_wcOption, reset=true){
    if(reset){ this.resetZip(_wcOption, [this.defaultCity]); }
    if(_wcOption.workerLocation[0].value.length==5){
      _wcOption.citiesByZip= [this.loadingCity];
      _wcOption.selectedCity = _wcOption.citiesByZip[0]; //select loading
      _wcOption.classCodes = [];
      let zipSearchSubscription = this.diceService.zipSearch(_wcOption.workerLocation[0].value).subscribe(response => {
        if(response[0]){
          _wcOption.citiesByZip = response;
          setTimeout(() => {
            let cityDropdown: any = document.getElementById('ratingCity'+this.wcLob.options[0].workerOptions.findIndex(option=> option == _wcOption));
            if(cityDropdown && reset){
              if(cityDropdown.options.length == 0){
                this.resetZip(_wcOption, [this.noCityAvailable]); //no city available to select
              } else if(cityDropdown.options.length > 1){ 
                _wcOption.citiesByZip.unshift(this.defaultCity); //add select... option to dropdown         
              }
              setTimeout(() => {
                _wcOption.selectedCity = _wcOption.citiesByZip.find(cityZip=>cityZip.city == cityDropdown.options[0].innerText); //default select first in list
                if(_wcOption.selectedCity.state){
                  this.updateClassCodes(_wcOption);
                }
              }, 50)
            } else { //copy quote - select city from initial quote OR new quote - set business address
              let match = _wcOption.citiesByZip.find(cityZip=>cityZip.city.toLowerCase() == _wcOption.workerLocation[1].value.toLowerCase());
              _wcOption.selectedCity = (match) ? match : _wcOption.citiesByZip[0]; //select first in list if no match
              this.updateClassCodes(_wcOption);
            }
          }, 50);
        } else{
          this.resetZip(_wcOption, [this.noCityAvailable]); //no city available to select
        }
        this.loading = false;
        this.diceFormLoaded = false;
      }, error=>{
        this.hasError = true;
        this.loading = false;
        this.resetZip(_wcOption, [this.noCityAvailable]); //no city available to select
        if(this.diceService.hasOpenModals()) {
          this.diceService.closeModal();
        }
        this.diceService.openModal('error', 'none', false, 'light-blue-backdrop', false, '');
      });
      this.diceService.runningServices.push(zipSearchSubscription);
    }
  }

  isDuplicateZip(cityState, _wcOption, _wcIdx){
    let isDupe = false;
    for(let i=0; i<this.wcLob.options[0].workerOptions.length; i++){
      if(this.wcLob.options[0].workerOptions[i].workerLocation[0].value == _wcOption.workerLocation[0].value && _wcIdx!==i){
        if(cityState.city == this.wcLob.options[0].workerOptions[i].workerLocation[1].value){
          isDupe = true; //remove cities from dropdown that have already been selected
          break;
        }
      }
    }
    return isDupe;
  }

  streetAddrInd(_wcOption:any){
    return _wcOption.workerLocation.findIndex((q:any) => q.keyValueID == 'WorkerStreetAdd');
  }

  addRemoveWCStreetAddr(_wcOption:any){
    let businessAddress = this.getAddress(this.addressTypeEnum.Business);
    let strtAddrState = this.lookupReferenceData.lobRules.WC.strtAddrStates.find(state => state == _wcOption.selectedCity.stateCode);
    let isBusinessAddr = _wcOption.workerLocation[0].value == businessAddress.zip.substring(0,5) && _wcOption.workerLocation[1].value.toLowerCase() == businessAddress.city.toLowerCase() && _wcOption.selectedCity.stateCode == businessAddress.state;
    let isFirstLocation = this.wcLob.options[0].workerOptions.findIndex(option => option == _wcOption) == 0;
    let isPrimaryMonopolistic = this.lookupReferenceData.lobRules.WC.monopolisticStates.find(state => state == businessAddress.state);
    let streetAddrInd = this.streetAddrInd(_wcOption);
    if(!isBusinessAddr && (strtAddrState || (isPrimaryMonopolistic && isFirstLocation))){
      if(streetAddrInd == -1){
        _wcOption.workerLocation.push(this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerLocation[4]);
      }
    } else if(streetAddrInd > -1) {
      _wcOption.workerLocation.splice(streetAddrInd,1);
    }
  }

  updateClassCodes(_wcOption) {
    _wcOption.classCodes = [];

    if(_wcOption.selectedCity){
      _wcOption.workerLocation[1].value = _wcOption.selectedCity.city; 
      _wcOption.workerLocation[2].value = _wcOption.selectedCity.stateCode + ' - ' + _wcOption.selectedCity.state;

      /* experience rating question add/remove */
      let experienceRatingInd = _wcOption.workerLocation.findIndex(q => q.keyValueID == 'WorkerExpRating');
      if(_wcOption.selectedCity.stateCode == 'CA'){ 
        if(experienceRatingInd>-1){
          _wcOption.workerLocation.splice(experienceRatingInd,1);
        }
      } else {
        if(experienceRatingInd == -1){
          _wcOption.workerLocation.splice(3, 0, this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerLocation[3]);
        }
      }

      /* street address question add/remove */
      this.addRemoveWCStreetAddr(_wcOption);

      /* filter class codes by effective date & state */
      if(this.diceQuoteForm.coverage.policyEffectiveDate && _wcOption.selectedCity.stateCode && !_wcOption.selectedCity.monopolisticState){
        let effectiveDate = new Date(this.diceQuoteForm.coverage.policyEffectiveDate);
        let effMonth = effectiveDate.getMonth() + 1;
        let effYearMonth = effectiveDate.getFullYear() + '-' + (effMonth < 10 ? '0' + effMonth : effMonth);
        _wcOption.classCodes = this.lookupReferenceData.wcClassCodes[effYearMonth][_wcOption.selectedCity.stateCode];
      
        /* set default codes & add tabs */
        for(let i=0; i<_wcOption.classCodes.length; i++){
          if(!_wcOption.workerClassCodes[i]){
            this.addClassCodeTab(i, _wcOption);
          }
          /* copy quote - if code on initial quote doesn't match the default, reset the form */
          if(_wcOption.workerClassCodes[i][0].selectedValues && _wcOption.workerClassCodes[i][0].selectedValues[0] !== _wcOption.classCodes[i].classCodeID){
            let classCodeQuestions = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerClassCodes[0];
            classCodeQuestions = classCodeQuestions.slice(0,5); //remove specify other
            classCodeQuestions[2].value = this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.YES; //set if any value
            this.updateNumOfEmp(classCodeQuestions);
            _wcOption.workerClassCodes[i] = classCodeQuestions;
          }
          _wcOption.workerClassCodes[i][0].additionalInfo = _wcOption.classCodes[i].classCodeID + ' - ' + _wcOption.classCodes[i].classCodeCaption; //for coverage, review, & detail page UI
          _wcOption.workerClassCodes[i][0].selectedValues = [_wcOption.classCodes[i].classCodeID]; //for coverage UI tab name
          _wcOption.workerClassCodes[i][0].value = _wcOption.classCodes[i].classCodeValue; //for submit API value
        }
        _wcOption.selectedClassCodeTab = 0;

        /* get persons list by eff date & state */
        this.getPersonsList(_wcOption);
      }
    }
  }

  updateNumOfEmp(_tab){
    _tab[1].value = null; //clear total payroll
    _tab[3].value = (_tab[2].value) ? 0 : null; //part-time emp default value
    _tab[4].value = (_tab[2].value) ? 0 : null; //full-time emp default value
    if(this.continueToReviewClicked) this.checkNonZeroPayroll();
  }

  defaultIfAny(question='PayrollServices'){
    if(question == 'PayrollServices'){
      let payrollServices = this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.YES;
      this.wcLob.options[0].workerOptions.forEach((option, wcIdx) => {
        option.workerClassCodes.forEach((code, tabInd) => {
          code[2].value = payrollServices; //set if any value
          this.updateNumOfEmp(code); //set part time & full time emp values
          setTimeout(() => {
            this.checkTabInvalid('class', wcIdx, tabInd); //check for tab errors
          }, 100);
        });
      });
    }
  }

  isPredefinedCode(_code, _list){
    return _list.find(code=> code.classCodeID==_code);
  }
  
  tabScroll(type, direction, wcIdx){
    let tab = document.getElementById(type+'-tabs'+wcIdx);
    if(tab){
      if(direction == 'right'){
        tab.scrollBy(500, 0);
      } else if(direction == 'left'){
        tab.scrollBy(-500, 0);
      } else{
        tab.scrollTo(tab.scrollWidth, 0);
      }
      setTimeout(() => {
        this.isScrollActive(type, wcIdx);
      }, 250);
    }
  }

  isScrollActive(type, wcIdx){
    let tab = document.getElementById(type+'-tabs'+wcIdx);
    let scrollLeft = document.getElementById(type+'-scroll-left'+wcIdx);
    let scrollRight = document.getElementById(type+'-scroll-right'+wcIdx);
    if((tab.scrollWidth - tab.scrollLeft) > tab.clientWidth){
      scrollRight.classList.add('scroll-active'); //make scroll blue
    } else {
      scrollRight.classList.remove('scroll-active'); //make scroll gray
    }
    if(tab.scrollLeft > 0){
      scrollLeft.classList.add('scroll-active'); //make scroll blue
    } else {
      scrollLeft.classList.remove('scroll-active'); //make scroll gray
    }
  }

  addClassCodeTab(index: any, wcOptions: any, isOtherCode: boolean=false) {
    let classCodeQuestions = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerClassCodes[0];
    classCodeQuestions = classCodeQuestions.slice(0,5); //remove specify other
    classCodeQuestions[2].value = this.wcLob.options[0].selectedOptions[1].value == this.yesNoEnum.YES; //set if any value
    this.updateNumOfEmp(classCodeQuestions);
    wcOptions.workerClassCodes.push(classCodeQuestions);
    wcOptions.selectedClassCodeTab = index;
    if(isOtherCode){
      wcOptions.workerClassCodes[index][0].additionalInfo = 'Other';
      wcOptions.workerClassCodes[index][0].selectedValues = ['Other'];
      this.updateWCOptions(wcOptions, index);
    }

    //autoscroll class code tabs when adding new
    setTimeout(() => {
      let wcInd = (this.wcLob.options[0].workerOptions.length>1) ? this.wcLob.options[0].workerOptions.findIndex(option=>option==wcOptions) : 0;
      this.tabScroll('class', 'end', wcInd);
    }, 100);
  };

  removeClassCodeTab(index, wcOptions){
    wcOptions.workerClassCodes.splice(index, 1);
    wcOptions.selectedClassCodeTab = (index!==0) ? index-1 : 0;

    //check if scroll is active
    setTimeout(() => {
      let wcInd = (this.wcLob.options[0].workerOptions.length>1) ? this.wcLob.options[0].workerOptions.findIndex(option=>option==wcOptions) : 0;
      this.isScrollActive('class', wcInd);
    }, 100);
  }

  addOfficerTab(index: any, wcOptions) {
    let personQuestions = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerPerson[0];
    personQuestions = personQuestions.slice(0,2); //remove dynamic fields
    wcOptions.workerPerson.push(personQuestions);
    wcOptions.selectedOfficerTab = index;

    /* default select if only 1 option for included/excluded is available */
    if(wcOptions.persons && (wcOptions.persons.excludedPersons.length==0 || wcOptions.persons.includedPersons.length==0)){
      if(wcOptions.persons.excludedPersons.length==0){ //default select included when excluded is not available
        personQuestions[0].value = personQuestions[0].displayOptions[0].answer;
        personQuestions[0].displayOptions[0].isSelected = true;
      } else { //default select excluded when included is not available
        personQuestions[0].value = personQuestions[0].displayOptions[1].answer;
        personQuestions[0].displayOptions[1].isSelected = true;
      }
      this.updatePersonsList(personQuestions[0].value, wcOptions, wcOptions.workerPerson.length-1); //set persons list
    }

    //autoscroll officer tabs when adding new
    setTimeout(() => {
      let wcInd = (this.wcLob.options[0].workerOptions.length>1) ? this.wcLob.options[0].workerOptions.findIndex(option=>option==wcOptions) : 0;
      this.tabScroll('officer', 'end', wcInd);
    }, 100);  
  };

  removeOfficerTab(index, wcOptions){
    wcOptions.workerPerson.splice(index, 1);
    wcOptions.selectedOfficerTab = (index!==0) ? index-1 : 0;

    if(wcOptions.workerPerson.length>0){
      //check if scroll is active
      setTimeout(() => {
        let wcInd = (this.wcLob.options[0].workerOptions.length>1) ? this.wcLob.options[0].workerOptions.findIndex(option=>option==wcOptions) : 0;
        this.isScrollActive('officer', wcInd);
      }, 100);
    }
  }

  resetPersons(_tabs, _person){
    _tabs.forEach(tab => {
      tab[1].displayOptions = _person;
      tab[1].selectedPerson = tab[1].displayOptions[0];
    });
  }

  getPersonsList(_wcOption){
    /* copy quote - person list loading */
    if(_wcOption.workerPerson.length>0){
      this.personListLoading = true;
      this.resetPersons(_wcOption.workerPerson, [this.loadingPerson]);
    }

    let request = { effDate: new Date(this.diceQuoteForm.coverage.policyEffectiveDate), stateCode: _wcOption.selectedCity.stateCode };
    let personListSubscription = this.diceService.fetchPersonList(request).subscribe((response:any) => {
      _wcOption.persons = response;

      /* update officers if they already exist */
      if(_wcOption.workerPerson.length > 0){
        _wcOption.workerPerson.forEach((personTab, tabInd) => {
          if(personTab[0].value){
            this.updatePersonsList(personTab[0].value, _wcOption, tabInd);
            let selectedPerson = _wcOption.workerPerson[tabInd][1].value && _wcOption.workerPerson[tabInd][1].displayOptions.find(type=> type.value == _wcOption.workerPerson[tabInd][1].value);
            if(selectedPerson) {
              _wcOption.workerPerson[tabInd][1].selectedPerson = selectedPerson;
              this.updateOfficerFields(tabInd, _wcOption);

              /* copy quote - dynamic fields after persons list API returns success */
              if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.Copy){
                let wcCopyQuote = this.diceQuoteForm.coverage.loBs.find(lob=>lob.lobCode == this.lobCodes.WC).options[0].workerOptions;
                let wcCopyOption = (wcCopyQuote) ? wcCopyQuote.find(location=> location.workerLocation[0].value == _wcOption.workerLocation[0].value && location.workerLocation[1].value == _wcOption.workerLocation[1].value) : null;
                if(wcCopyOption && wcCopyOption.workerPerson.length > 0){
                  wcCopyOption.workerPerson[tabInd].forEach(selection => {
                    this.copySelections(_wcOption.workerPerson[tabInd], selection);
                  });
                }
              }
            } else{ //reset person type as selected value is no longer supported
              _wcOption.workerPerson[tabInd] = _wcOption.workerPerson[tabInd].slice(0,2);
              _wcOption.workerPerson[tabInd][1].value = ''
            }
          }
        });
        this.personListLoading = false;
      }
    }, error=>{
      this.hasError = true;
      if(_wcOption.workerPerson.length>0){
        this.resetPersons(_wcOption.workerPerson, [this.noPersonAvailable]);
      }
      if(this.diceService.hasOpenModals()) {
        this.diceService.closeModal();
      }
      this.diceService.openModal('error', 'none', false, 'light-blue-backdrop', false, '');
      this.personListLoading = false;
    });
    this.diceService.runningServices.push(personListSubscription);
  }

  updatePersonsList(_includedExcluded, _wcOption, _tabInd){
    _wcOption.workerPerson[_tabInd][1].selectedPerson = this.defaultPerson; //reset person type
    _wcOption.workerPerson[_tabInd] = _wcOption.workerPerson[_tabInd].slice(0,2); //reset dynamic fields
    let included = (_wcOption.persons.includedPersons.length>1) ? [this.defaultPerson].concat(_wcOption.persons.includedPersons) : _wcOption.persons.includedPersons;
    let excluded = (_wcOption.persons.excludedPersons.length>1) ? [this.defaultPerson].concat(_wcOption.persons.excludedPersons) : _wcOption.persons.excludedPersons;
    _wcOption.workerPerson[_tabInd][1].displayOptions = (_includedExcluded=='Included') ? included : excluded;

    /* person list no longer supports included/exluded selection */
    if(_wcOption.workerPerson[_tabInd][1].displayOptions.length == 0){
      let personQuestions = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerPerson[0];
      personQuestions = personQuestions.slice(0,2);
      _wcOption.workerPerson[_tabInd] = personQuestions; //reset officer tab
    } else{
      _wcOption.workerPerson[_tabInd][1].selectedPerson = _wcOption.workerPerson[_tabInd][1].displayOptions[0]; //default select first in list
      if(_wcOption.workerPerson[_tabInd][1].selectedPerson.value){
        this.updateOfficerFields(_tabInd, _wcOption);
      }
    }
  }

  updateOfficerFields(_tabInd, _wcOption){
    _wcOption.workerPerson[_tabInd] = _wcOption.workerPerson[_tabInd].slice(0,2); //reset dynamic fields
    if(_wcOption.workerPerson[_tabInd][1].selectedPerson.value){
      _wcOption.workerPerson[_tabInd][1].value = _wcOption.workerPerson[_tabInd][1].selectedPerson.value;
      _wcOption.workerPerson[_tabInd][1].additionalInfo = _wcOption.workerPerson[_tabInd][1].selectedPerson.caption; //caption for review page
    } else {
      let selected = _wcOption.workerPerson[_tabInd][1].displayOptions.find(person=> person.value == _wcOption.workerPerson[_tabInd][1].value);
      _wcOption.workerPerson[_tabInd][1].selectedPerson = (selected) ? selected : '';
    }

    let role = _wcOption.workerPerson[_tabInd][1].selectedPerson.caption;
    let included = _wcOption.workerPerson[_tabInd][0].value == 'Included';
    let state = _wcOption.selectedCity.stateCode;
    let fields = this.diceService.getReferenceData().lobCoverageQA.WC.options[0].workerOptions[0].workerPerson[0];
    
    /* add dynamic fields based on role, included/excluded, and state */
    let question = Object.values(this.officers).find((person:any)=>(person.caption && role.startsWith(person.caption))).field;
    _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == question));

    if(state == 'CA' || state == 'NY' || state == 'PA'){
      _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.Title.field));
      if(state == 'PA' && !included){
        _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.Ownership.field));
        if(role == this.officers.Officers.fullCaption){
          _wcOption.workerPerson[_tabInd].push(fields.find(option=>option.fullText == this.officers.ShortenedTitle.field));
        }
      }
    }
  }

  underlyingPolicyOptions(_isCopyQuote = false){
    let displayOptions = this.umLob.options[0].selectedOptions[1].displayOptions;
    displayOptions.forEach(option => {
      option.disabled = true;
      if(!_isCopyQuote) this.underlyingPolicySelected(false, option); //uncheck options only on new quote
      if(this.umLob.options[0].selectedOptions[0].value == this.yesNoEnum.NO){
        if(option.answer == displayOptions[0].answer){
          if(!_isCopyQuote) this.underlyingPolicySelected(true, option);
        }else if(option.answer == displayOptions[1].answer && this.isBusinessAutoAdded){
          option.disabled = false;
        }else if(option.answer == displayOptions[2].answer && this.isWorkCompAdded){
          option.disabled = false;
        }
      } else if(this.umLob.options[0].selectedOptions[0].value == this.yesNoEnum.YES) {
        option.disabled = false;
      }
    });
  }

  underlyingPolicySelected(_checked, _option) {
    _option.isSelected = _checked;
    if(_checked) {
      let el = this.underlyingPolicyList.find(itm => itm === _option.text);
      if(!el) 
        this.underlyingPolicyList.push(_option.text);      
    } else {
      let el = this.underlyingPolicyList.find(itm => itm === _option.text);
      console.log('el: ', el);
      if(el)
        this.underlyingPolicyList.splice(this.underlyingPolicyList.indexOf(el),1);
    }
    this.umLob.options[0].selectedOptions[1].value = this.underlyingPolicyList.join(", ");
    console.log(this.umLob.options[0].selectedOptions[1].value);
  }
  
  fileBrowseHandler(_files) {
    this.listAllFiles(_files);
  }

  listAllFiles(_files){
    console.log('_event :: ', _files);

    if(_files.currentTarget && _files.currentTarget.files){
      _files = _files.currentTarget.files;
    }

    if (_files.length === 0) {
      console.log("No file selected!");
      return
    }

    if(this.attachmentError !== this.errorMessages.attachmentDocTypes){
      this.attachmentError = null;
    }
    this.docFiles = this.diceService.getSupportingDocuments();

    this.uploadedFileSize = 0;
    this.docFiles.forEach(document => {
      this.uploadedFileSize += (Number(document.size));
    });

    Array.from(_files).forEach((_file:any)=>{

      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      _file.fileName = _file.name;
      _file.documentType = null;

      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size))) < this.fileUploadConfig.MaxUploadSize){
        this.uploadedFileSize += (Number(_file.size));
        this.diceService.addSupportingDocument(_file);
      } else if(_file.size == 0){
        this.attachmentError = this.fileUploadConfig.AttachmentNoContent;
        console.log("File has no content");
      }else{
        this.attachmentError = this.fileUploadConfig.AttachmentExceeds;
        console.log("File size exceeding");
      }
    });
    //_event.target.value = null; //Helps to select same file multiple times

    this.docFiles = this.diceService.getSupportingDocuments();

    console.log(this.docFiles);
  }

  removeListItem(_index){
    //this.files.splice(_index, 1);
    this.diceService.getSupportingDocuments().splice(_index, 1);
    this.uploadedFileSize = 0;
    this.docFiles.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.checkAndupdateDocType();
    if(this.uploadedFileSize < this.fileUploadConfig.MaxUploadSize){
      this.attachmentError = null;
    }
  }  

  checkAndupdateDocType(_docType = null, _docIdx = null) {
    let _isDocTypeSelected = true;

    for(let i=0; i < this.docFiles.length; i++) {
      console.log('Document Type ::: ', this.docFiles[i].documentType);
      if(this.docFiles[i].documentType === null) {
        _isDocTypeSelected = false;
      }
    }
    
    if(_docIdx) {
      console.log('_event.target.value :: ', _docType);
      this.diceService.getSupportingDocuments()[_docIdx].documentType = _docType;
    }

    this.isAllDocTypesSelected = _isDocTypeSelected;
    this.attachmentError = (this.docFiles.length>0 && !this.isAllDocTypesSelected && this.continueToReviewClicked) ? this.errorMessages.attachmentDocTypes : null;
  }

  uploadAllDocs() {
    let newSupportingDocuments = [];
    this.isSubmitted = true;
    
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }

    if(this.diceQuoteForm.acceptAcknowledgement){
      this.diceService.openModal('none', this.generateQuoteModal, false, 'dark-blue-backdrop', 'static', 'dice-modal', '', true);

      if(this.diceService.getSupportingDocuments().length>0){
        this.diceService.getSupportingDocuments().forEach((document, index) => {
          let newFile:any = {};
          newFile.uniqueName = document.uniqueName;
          newFile.fileName= document.name;
          newFile.lastModified= document.lastModified;
          newFile.lastModifiedDate= document.lastModifiedDate;
          newFile.webkitRelativePath= document.webkitRelativePath;
          newFile.size= document.size;
          newFile.fileType= document.type;
          newFile.documentType = document.documentType;

            ((_document, _newFile)=>{
              let fReader = new FileReader();
              // Add complete behavior
              fReader.onload = ()=>{
                _newFile.contentStream = fReader.result;
                _newFile.contentStream = _newFile.contentStream.split("base64,")[1];

                //console.log(_newFile.content);
                newSupportingDocuments.push(_newFile);

                if(newSupportingDocuments.length == this.diceService.getSupportingDocuments().length){
                  this.submitQuote(newSupportingDocuments);
                }else{
                  console.log("uploading file " + index);
                }
              };
              fReader.readAsDataURL(_document);
            })(document, newFile);   
        });
      }else{        
          this.submitQuote([]);
      }
    }
  }

  /*** SubmitQuote - Used for submitting the final Quote Application For New and Copy ***/
  submitQuote(_newSupportingDocuments) {
    this.submitBtnClicked = true;
    this.diceQuoteForm.attachments = _newSupportingDocuments;

    /* update WC submit values */
    if(this.isWorkCompAdded && !this.wcLob.offlineBanner){
      let wcLob = this.diceQuoteForm.coverage.loBs.find(_lob=> _lob.lobCode==this.lobCodes.WC);
      wcLob.options[0].workerOptions.forEach(option => {
        option.workerClassCodes.forEach(code => {
          if(code[2].value){
            code[2].value = 'true';
            code[1].value = 0; //total payroll value
          } else{
            code[2].value = 'false';
          }
        });
        option.workerLocation[2].value = option.selectedCity.stateCode;
      });
    }
    
    console.log('Final Dice QuoteForm :: ', this.diceQuoteForm);
    if(this.diceQuoteDetails.diceQuoteType === this.diceQuoteTypes.New) {
      let submitQuoteSubscription = this.diceService.submitDiceQuoteQueue(this.diceQuoteForm).subscribe(taskId => {
        console.log("Polling TaskID :: ", taskId);
        

        /* Polling started */
        let pollingNewQuoteSubmitSubscription = this.diceService.queueTask(taskId).subscribe(queueResp => { 
          console.log("finally its successful! " + queueResp);
          let finalresponse: any = queueResp;
          this.resetAllForms();
          this.dnbEventsModel.eventType = DandBEventsTypes.ChoiceSubmitted;          

          setTimeout(()=>{
            this.router.navigate(['newbusiness/dice/quote/' + finalresponse.applicationId +'/'+ finalresponse.quoteId], {state: {isNewQuote: true, dnbEventModel: this.dnbEventsModel}});
            this.diceService.closeModal();
          }, 200);
        },error=>{
          console.log("opps!! got error after waiting long! " + error);
          this.resetAllForms();
          this.diceService.closeModal();
          this.hasError = true;
          this.router.navigate(["/error"]);
        });

        this.diceService.runningServices.push(pollingNewQuoteSubmitSubscription);
        /* Polling ended */
        
      }, error=>{
        this.resetAllForms();
        this.diceService.closeModal();
        this.hasError = true;
      });

      this.diceService.runningServices.push(submitQuoteSubscription);
    } else {
      this.diceCopyQuoteModel = {
        applicationId: this.diceQuoteDetails.applicationId,
        accountFein: this.diceQuoteForm.accountFein,
        attachments: this.diceQuoteForm.attachments,
        quoteId:  this.diceQuoteDetails.quoteId,
        policyEffectiveDate: this.diceQuoteForm.coverage.policyEffectiveDate,
        annualGPC:  this.diceQuoteForm.coverage.annualGPC,
        yearGPC: this.diceQuoteForm.coverage.yearGPC ,
        mediaTypes:  this.diceQuoteForm.coverage.mediaTypes,
        loBs: this.diceQuoteForm.coverage.loBs
      }
  
      console.log('this.diceCopyQuoteModel :: ', this.diceCopyQuoteModel);

      let submitCopyQuoteSubscription = this.diceService.submitDiceCopyQuoteQueue(this.diceCopyQuoteModel).subscribe(taskId => {

        console.log("Polling TaskID :: ", taskId);
        /* Polling started */
        let pollingCopyQuoteSubmitSubscription = this.diceService.queueTask(taskId).subscribe(queueResp => { 
          console.log("finally its successful! " + queueResp);
          
          if(environment.logRocketKey){
            LogRocket.log("(LogRocket) DICERequestSubmitted : " + true);
            let loggedInUser = this.diceService.getLoggedInProfile();
            LogRocket.identify(loggedInUser.UID.toString(), {
              DICERequestSubmitted: true
            });
          }

          let finalresponse: any = queueResp;
          this.diceCopyQuoteModel = new CopyQuote();
          this.diceQuoteForm = new DiceQuoteForm();
          this.router.navigateByUrl('newbusiness/dice/quote/' + finalresponse.applicationId +'/'+ finalresponse.quoteId);
          this.diceService.closeModal();
          this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
          this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
          this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
          this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;
          this.docFiles = [];
          this.existingAttachments = [];
          this.diceService.resetSupportingDocuments();

        },error=>{
          console.log("opps!! got error after waiting long! " + error);
          this.diceCopyQuoteModel = new CopyQuote();
          this.diceQuoteForm = new DiceQuoteForm();
          this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
          this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
          this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
          this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;
          this.docFiles = [];
          this.existingAttachments = [];
          this.diceService.resetSupportingDocuments();

          this.diceService.closeModal();
          this.hasError = true;
          this.router.navigate(["/error"]);
        });

        this.diceService.runningServices.push(pollingCopyQuoteSubmitSubscription);
        /* Polling ended */
      }, error=>{
        this.diceCopyQuoteModel = new CopyQuote();
        this.diceQuoteForm = new DiceQuoteForm();
        this.glLob = this.lookupReferenceData.lobCoverageQA.GL;
        this.auLob = this.lookupReferenceData.lobCoverageQA.AU;
        this.umLob = this.lookupReferenceData.lobCoverageQA.UMB;
        this.wcLob = this.lookupReferenceData.lobCoverageQA.WC;
        this.existingAttachments = [];
        this.docFiles = [];
        this.diceService.resetSupportingDocuments();

        this.diceService.closeModal();
        this.hasError = true;
      });
  
      this.diceService.runningServices.push(submitCopyQuoteSubscription);
    }
    
  }

  setInitialDnBEventLogModel() {
    this.currentUserDts = this.diceService.getLoggedInProfile();
    this.dnbEventsModel = new DnBEventLog();
    this.dnbEventsModel.channelName = Channel.DICE;
    this.dnbEventsModel.psoUser = this.currentUserDts.email;
    this.dnbEventsModel.userSessionId = this.currentUserDts.SID;
    if(this.selectedNiche)
      this.dnbEventsModel.niche = this.selectedNiche.nicheName;
    if(this.selectedProducer)
      this.dnbEventsModel.producer = this.selectedProducer.code;
    this.dnbEventsModel.flowSessionId = uuidv4();
  }

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}